/* DCG V3.1.2 · 22 OCT 2026 · round 3, item 2 (D-SP-52, PROPOSED): §M, the theme owns the search parameters: on any settings storepass.js parses, sort_defaults the theme's and dont_use_product_line; settings not the theme's file also its theme-owned keys and opening sorts; every search of the listing with the theme's product line, its in_stock said, a page's sort and limit */
/* DCG V3.1.2 · 22 OCT 2026 · round 3, item 1 (Cole; docs/PROMPT-V3-1-2-round-3-weight-and-dashboard.md): §K reads the out-of-stock part at the page size, only where the in-stock part does not fill the page; a card stays on the page of this visit's listing it was drawn on first (sessionStorage dcg_drawn), a page left short filled once; "none out of stock" read from storepass.js's own count; the in-stock count kept for the visit (dcg_instock_counts) */
/* DCG V3.1.2 · 21 OCT 2026 · the end gates (D-SP-49's Tag group drawn empty on tcg-supplies): §L says the Tag group's count after the whitelist (dcg:storepass-facet), never StorePass's own, so the panel hides a Tag group left with one value or none */
/* DCG V3.1.2 · 21 OCT 2026 · the addendum's gate (the filters suite on the draft): "Clear all" puts the site's default back, the visit's In Stock Only choice forgotten (dcg:storepass-cleared; forgetStock() for the safety net) */
/* DCG V3.1.2 · 21 OCT 2026 · the addendum, D-SP-49 (decided by Cole): §L, StorePass's Tag group given the values of the tag groups the settings file names (dcg.tag_groups; a tag's group its word before "_"), a group StorePass adds held back until named; an empty list asks nothing; tagGroups(), tagShown() for the safety net's Tags facet */
/* DCG V3.1.2 · 21 OCT 2026 · the addendum's gate: a collection in stock only by Shopify's own rule (dcg.in_stock_only: the singles collections) is left as storepass.js asks it, no two searches and no in-stock count (nothing in it to put after) */
/* DCG V3.1.2 · 21 OCT 2026 · the addendum, item 1's gate: the whole listing read 250 at a time for its out-of-stock part (one answer for a listing of 250 or fewer: StorePass's ties at a page's edge moved cards between two page loads, 8 twice and 9 left out on flesh-and-blood-sealed-product under A-Z)
/* DCG V3.1.2 · 21 OCT 2026 · the addendum, item 1 amended (Cole, 21 OCT; docs/PROMPT-V3-1-2-addendum-in-stock-first.md): §K, in stock first across the whole listing (two of StorePass's searches stitched: the listing in stock, then the rest of it with its in-stock products left out; the two price sorts on a singles listing left to price), the in-stock count said for the count line; §I: In Stock Only off by default, the visitor's choice either way kept for the visit; stockChosen() */
/* DCG V3.1.2 · 21 OCT 2026 · item 1's end gate: stockDefaultOn() (the safety net's) reads the address's in_stock where the default is on, as storepass.js does for its own listing: ?in_stock= holds In Stock Only off for that page on the net too */
/* DCG V3.1.2 · 20 OCT 2026 · item 6 (Cole, 20 OCT; docs/PROMPT-V3-1-2-adjustments.md): §J, one search per change (a search asked again given its answer, a group's one value, the next change overtaking a search on its way); its gate: a value list in stock given the whole listing's one value (storepass.js asks for it only from a page's first change) */
/* DCG V3.1.2 · 20 OCT 2026 · item 1 (Cole: In Stock Only on by default, everywhere, remembered; docs/PROMPT-V3-1-2-adjustments.md): §I. The visitor's choice kept for the visit (sessionStorage dcg_in_stock) and given to the settings storepass.js holds, so its re-reads of the address keep it; an address's in_stock wins ("false"/"0"/"off"/"no" put back as off); a page's own hold (All Singles); stockDefaultOn() for the safety net */
/* DCG V3.1.0 · 17 OCT 2026 · the decisions round (D-SP-32 LOCKED with one change; Cole, 17 OCT; REPORT-V3-1-0-final §7.3 (b)): no stock badge while a card's button is out of stock (a sold-out card; an out-of-stock condition picked); "N left" and "In stock" as before */
/* DCG V3.1.0 · 17 OCT 2026 · item 10 (the rename round; Cowork's audit of 17 OCT): StorePass's picture link on each card, a picture with no words, is named with the card (52 to 56 unnamed links on a collection page) */
/* DCG V3.1.0 · 17 OCT 2026 · item 0 (D-SP-41 amended, LOCKED, Cole 17 OCT): no wishlist heart on any card: the guard no longer adds .dcg-wishlist-wrap (the card dress, the coming-soon row) and its wishlist helpers and click handler are gone; the wishlist lives on the product page (shop.js) and /pages/wishlist, as before */
/* DCG V3.1.1 · 20 OCT 2026 · hotfix.1, F6 (Cowork's live phone pass, 20 OCT): on a listing page a sort written in the address by its short name (?sort=price-desc) is put back as its label (SORT_LABELS) in place, before storepass.js reads it: StorePass's Sort button read "Sort: price-desc" (the search already went as the label), and the safety net opened such an address on Sales */
/* DCG v2-10-13 · 16 OCT 2026 · item 4a: ?sort=created-desc leaves as "Recently Added" (SORT_LABELS); item 4b (D-SP-29 amended): a failed count call of the guard's own is announced as failed, for the count line; item 3: an event tagged retail reads "Register in store" in its notice, a retail product that is not an event "In-store only" as before */
/* DCG v2-10-12 · 16 OCT 2026 · item 4 (D-SP-40, PROPOSED): a retail card gets no stock badge ("Out of stock", "N left"), whatever its inventory */
/* DCG v2-10-11 · 16 OCT 2026 · item 1a (D-SP-39, PROPOSED): the set chosen in the panel put back into storepass.js's own Sort / In Stock Only / price search on the way out (it sends set_name empty); item 2 (a D-SP-38 defect): a count only for a search of the listing's own shape (product_line, shopify_collection_id, the listing's page size), never the header's suggestions; item 3: in_stock=undefined leaves as in_stock=true; item 6: names on each card's quantity buttons, quantity box and condition select */
/* DCG v2-10-10 · 15 OCT 2026 · item 1 (D-SP-38, PROPOSED): StorePass's 14 OCT contract. SORT_LABELS: a short sort name (alpha-asc, price-asc, ...) leaves as its label; a page answer that counts only itself, with no count request of storepass.js's own beside it, is counted by the guard (with_count=true&no_track=true, once a search) and announced for the count line and the pager; the answer itself untouched */
/* DCG v2-10-8 · 15 OCT 2026 · item 2: no in-stock-first reorder under "Price: Low-High" and "Price: High-Low" (the setting StorePass reads is set as each search leaves); item 3a: each answer is announced with its products' keys, its address and whether it is a cursor; quietSearch() for the safety net's one check of page 2 (not announced) */
/* DCG v2-10-4 · 13 OCT 2026 · every search is announced when it starts and when it fails (no answer in 8 s, a refusal, a network error), for the collection safety net (D-SP-37, PROPOSED); the condition row on every card (item 1) */
/* DCG v2-9-1 · 10 OCT 2026 · every search answer announced with its request, for the count line and the pager (D-SP-29); D-SP-10, D-SP-14, card dress (the condition label wraps, v2-8-1); result product types for the filter panel (D-SP-17); the Printing bridge: tag added to StorePass's search request, card opened on the printing (D-SP-22, D-SP-23) */
/* =========================================================
   Desert City Games — StorePass results guard (D-SP-10)
   File: assets/dcg-storepass-guard.js

   StorePass (assets/storepass.js, vendor, never edited) draws the product
   cards on collection and search pages and adds to cart with its own
   fetch("/cart/add.js"). It checks stock only, so the DCG rules that live in
   dcg-product-card.js / dcg-cart-bridge.js never run there. This file puts
   them back from the outside:

     §A  Tag map        — reads StorePass's own /saas/search responses (clone)
     §B2 Card dress     — every card gets what the DCG card has and CSS
                           cannot make from StorePass's markup: the stock pip
                           beside the condition control, the condition shown
                           without its price, and the image stage for a
                           single or a sealed product (DCG v2-6-2; the
                           wishlist heart until V3.1.0)
     §B  Card decoration — retail / coming-soon cards look like DCG cards
                           (port of dcg-product-card.js BRANCH 1 + BRANCH 2
                           and its "Retail Only" image badge, step 3b);
                           a card whose selected variant is $0.00 reads
                           "Price pending" with no cart controls (D-SP-14)
     §C  Click backstop — StorePass's /cart/add.js is blocked for retail,
                           coming-soon and $0.00 variants (D-SP-14), limit:N
                           is pre-flighted, cart refreshed
     §D  Card-style tripwire — warns if StorePass's card style is not
                           "modern-simple"; never sends a /cart.php request

   Load order: deferred, immediately BEFORE storepass.js, so window.fetch is
   wrapped before StorePass makes its first call. dcg-utils.js and
   dcg-cart-enforcer.js are deferred in <head> and have already run.

   Nothing here may throw into StorePass: every wrapped call returns the
   upstream promise or a real Response.
========================================================= */
(() => {
  'use strict';

  window.DCG = window.DCG || {};
  // One wrap per page, even if the tag is included twice.
  if (window.DCG.storepassGuard || typeof window.fetch !== 'function') return;

  // ── StorePass markup this file relies on (storepass.js "modern-simple"
  //    card). Read from the bundle, not from a rendered page — check these on
  //    the draft theme before trusting the decoration.
  const LISTING_ID       = 'product-listing-container';
  const CARD_SELECTOR    = '.store-pass-product';
  const LINK_SELECTOR    = 'a[href*="/products/"]';
  const CTA_SELECTOR     = '.store-pass-product-cta';
  const CONTROL_SELECTOR = [
    CTA_SELECTOR,                                   // add-to-cart button
    '.store-pass-product-quantity-section',         // − [qty] +
    '.store-pass-product-variant-button-section',   // variant buttons
    '.store-pass-product-select-area'               // variant <select> (condition_style: dropdown)
  ].join(', ');
  // Price pending (D-SP-14) hides less: the variant <select> stays, so the
  // customer can switch to a priced condition.
  const PRICE_CONTROL_SELECTOR = [
    CTA_SELECTOR,
    '.store-pass-product-quantity-section'
  ].join(', ');
  const SELECT_SELECTOR  = '.store-pass-product-select-area select';
  const MEDIA_SELECTOR   = '.store-pass-product-image-container';
  const INFO_SELECTOR    = '.store-pass-product-info';
  const TITLE_SELECTOR   = '.store-pass-product-title';

  // Marks left on the cards. Attributes, not classes: React owns className on
  // these nodes and never touches attributes it doesn't know about.
  const STATE_ATTR  = 'data-dcg-guard';          // on the card: retail | retail-preorder | coming-soon | price-pending
  const HANDLE_ATTR = 'data-dcg-guard-handle';   // on the card: product the decoration was built for
  const NODE_ATTR   = 'data-dcg-guard-node';     // on every node this file inserts
  const HIDDEN_ATTR = 'data-dcg-guard-hidden';   // on every StorePass control this file hides
  // §B2 (card dress) keeps its own marks, so the rule-state code above never removes its nodes.
  const DRESS_ATTR  = 'data-dcg-dress';          // on every node §B2 inserts
  const MEDIA_ATTR  = 'data-dcg-media';          // on the card: single | sealed
  const STOCK_SELECTOR       = '.store-pass-product-inventory-quantity';   // StorePass's "N left"
  const SELECT_AREA_SELECTOR = '.store-pass-product-select-area';
  const OOS_CLASS            = 'store-pass-product-tag-oos';               // on the button: selected variant has no stock

  const upstreamFetch = window.fetch;

  // ── Helpers ───────────────────────────────────────────────────────────────

  // "/products/<handle>" from any product URL StorePass builds: absolute,
  // root-relative, or "/collections/<c>/products/<handle>" on collection pages.
  function handleFromUrl(url) {
    if (!url) return null;
    let path;
    try { path = new URL(String(url), window.location.origin).pathname; }
    catch (_) { path = String(url); }
    const m = path.match(/\/products\/([^/?#]+)/);
    if (!m) return null;
    let handle = m[1];
    try { handle = decodeURIComponent(handle); } catch (_) {}
    return handle.toLowerCase() || null;
  }

  // Same-origin product page path from the form's sections_url, or null.
  function productPagePath(url) {
    try {
      const u = new URL(String(url), window.location.origin);
      if (u.origin !== window.location.origin) return null;
      return handleFromUrl(u.pathname) ? u.pathname + u.search : null;
    } catch (_) { return null; }
  }

  // Matches [YYYY-MM-DD] and formats as "May 22, 2026"
  // (same as dcg-product-card.js extractReleaseDate).
  function extractReleaseDate(titleText) {
    const m = (titleText || '').match(/\[(\d{4})-(\d{2})-(\d{2})\]/);
    if (!m) return null;
    try {
      const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
      return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    } catch (_) { return null; }
  }

  // retail > coming-soon, same tests as dcg-product-card.js (case-insensitive,
  // whole tag). retail always wins; pre-order only changes the retail wording.
  function ruleState(tags) {
    const has = name => tags.some(t => t.toLowerCase() === name);
    if (has('retail')) return has('pre-order') ? 'retail-preorder' : 'retail';
    if (has('coming-soon')) return 'coming-soon';
    return '';
  }

  // ── Price pending (D-SP-14) ───────────────────────────────────────────────
  // A variant priced 0 cannot be ordered; products tagged `event-ticket` are
  // exempt (free events). Same rule and message as dcg-cart-enforcer.js §3b.
  const PRICE_PENDING_MESSAGE = "Price pending - this item isn't available to order yet.";

  // cents: whole number, or null when the price is not known.
  function pricePending(cents, tags) {
    return cents === 0 && !tags.some(t => t.toLowerCase() === 'event-ticket');
  }

  function blockMessage(state, title) {
    if (state === 'retail-preorder') return 'Pre-order in-store — contact us to pre-order this item.';
    if (state === 'retail') return 'In-store only — contact us to purchase this item.';
    const releaseDate = extractReleaseDate(title);
    return releaseDate
      ? 'Coming soon — releasing ' + releaseDate + '.'
      : 'Coming soon — this item can’t be ordered yet.';
  }

  function toast(message) {
    try {
      const enforcer = window.DCG.enforcer;
      if (enforcer && typeof enforcer.showToast === 'function') {
        enforcer.showToast(message);
        return;
      }
    } catch (_) {}
    console.warn('[DCG guard] ' + message);
  }

  // Shaped like Shopify's own /cart/add.js error so any caller can read it.
  function blockedResponse(status, description) {
    return new Response(
      JSON.stringify({ status: status, message: 'Cart Error', description: description }),
      {
        status: status,
        statusText: { 404: 'Not Found', 422: 'Unprocessable Entity', 503: 'Service Unavailable' }[status] || '',
        headers: { 'Content-Type': 'application/json; charset=utf-8' }
      }
    );
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §A  TAG MAP
  // handle → { handle, productId, title, tags: string[] | null,
  //            variantIds: Set<string>, variantPrices: Map<string, cents> }
  // tags stays null until a source actually supplies them: StorePass's header
  // search asks for a short field list, and "no tags sent" must not read as
  // "product has no tags". variantPrices holds only the prices a source sent
  // (StorePass: variantInfo[].price, in dollars; kept here in cents).
  // ═════════════════════════════════════════════════════════════════════════

  const productsByHandle  = new Map();
  const handleByVariantId = new Map();   // String(variantId) → handle
  const handleByProductId = new Map();   // String(productId) → handle

  function normaliseTags(raw) {
    if (Array.isArray(raw)) return raw.map(t => String(t).trim()).filter(Boolean);
    if (typeof raw === 'string') return raw.split(',').map(t => t.trim()).filter(Boolean);
    return null;
  }

  // Records one product from a StorePass search response (url, display_name,
  // tags, variantInfo). Only StorePass's index goes into this map. What Shopify
  // says at click time is kept apart: shopifyProducts (§C) and clickOverrides (§B).
  function recordProduct(p) {
    if (!p || typeof p !== 'object') return null;
    const handle = handleFromUrl(p.url) || (p.handle ? String(p.handle).toLowerCase() : null);
    if (!handle) return null;

    let entry = productsByHandle.get(handle);
    if (!entry) {
      entry = { handle: handle, productId: '', title: '', tags: null, variantIds: new Set(), variantPrices: new Map(), variantTitles: new Set() };
      productsByHandle.set(handle, entry);
    }

    // Shopify product id (StorePass sends it as product_id): the click backstop finds a card's handle by it (§C).
    if (p.product_id != null) {
      entry.productId = String(p.product_id);
      handleByProductId.set(entry.productId, handle);
    }

    // display_name is the Shopify product title, "[YYYY-MM-DD]" suffix included.
    // StorePass's `name` field is never used: it strips the brackets, so the
    // release date can't be read from it.
    if (p.display_name) entry.title = String(p.display_name);
    // v2-10-13 (item 3): the product type, which tells an event ("Events", "Events - <game>")
    if (p.productType || p.product_type) entry.productType = String(p.productType || p.product_type);

    const tags = normaliseTags(p.tags);
    if (tags) entry.tags = tags;

    const variants = Array.isArray(p.variantInfo) ? p.variantInfo
      : (Array.isArray(p.variants) ? p.variants : []);
    variants.forEach(v => {
      if (!v || v.id == null) return;
      const id = String(v.id);
      entry.variantIds.add(id);
      if (v.title) entry.variantTitles.add(String(v.title));
      handleByVariantId.set(id, handle);
      // StorePass sends the variant price as a number of dollars (0.41, 0).
      const dollars = (v.price === null || v.price === undefined || v.price === '') ? NaN : Number(v.price);
      if (Number.isFinite(dollars) && dollars >= 0) entry.variantPrices.set(id, Math.round(dollars * 100));
    });

    return entry;
  }

  // DCG v2-7 (D-SP-17): which Shopify product types a search answer holds
  // ("One Piece Single", "MTG Single" …). dcg-storepass-filters.js uses it to
  // know which game a page of results is. Only an answer with products in it
  // is announced (a count answer and a value-list answer have none; a value
  // list's entries have no url). StorePass leaves the type empty for some
  // products (Digimon singles, 09 OCT): then `productTypes` is empty and
  // `products` still says how many there were.
  let lastResults = { productTypes: [], products: 0 };
  function announceResultTypes(products) {
    try {
      const types = [];
      let count = 0;
      (Array.isArray(products) ? products : []).forEach(p => {
        if (!p || typeof p !== 'object' || !p.url) return;
        count++;
        const t = p.productType || p.product_type;
        if (t && types.indexOf(String(t)) === -1) types.push(String(t));
      });
      if (!count) return;
      lastResults = { productTypes: types, products: count };
      document.dispatchEvent(new CustomEvent('dcg:storepass-results', { detail: { productTypes: types.slice(), products: count } }));
    } catch (_) { /* never into StorePass */ }
  }

  // DCG v2-9-1: every search answer is also announced with the request it
  // answers, for assets/dcg-storepass-paging.js (the count line and the
  // pager). StorePass's listing sends two requests for a page of results: the
  // products, and the same request again with with_count=true, whose answer
  // holds the count. A value-list answer (return_type=...) is not announced.
  const productKey = p => String((p && (p.product_id || p.id || p.handle || p.url)) || '');
  function announceSearch(url, data, extra) {
    try {
      if (!url || !url.searchParams || url.searchParams.get('return_type')) return;
      const query = {};
      url.searchParams.forEach((v, k) => { query[k] = v; });
      document.dispatchEvent(new CustomEvent('dcg:storepass-search', { detail: {
        query: query,
        isCount: url.searchParams.get('with_count') === 'true',
        products: Array.isArray(data.products) ? data.products.length : 0,
        count: typeof data.count === 'number' ? data.count : null,
        estimate: data.countEstimate === undefined || data.countEstimate === null ? null : String(data.countEstimate),
        pages: typeof data.pages === 'number' ? data.pages : null,
        // v2-10-8 (item 3a): which products the page holds, and whether the reply is a cursor (StorePass's
        // dashboard switch "Use Shopify for initial collection results" on), for the safety net's page-2 check
        ids: Array.isArray(data.products) ? data.products.map(productKey) : [],
        endpoint: url.origin + url.pathname,
        cursor: !!(data.nextPageParameters && data.nextPageParameters.page_info),
        byGuard: !!(extra && extra.byGuard)     // v2-10-10: a count the guard asked for itself (completeCount)
      } }));
    } catch (_) { /* never into StorePass */ }
  }

  // DCG v2-10-4 (item 6; D-SP-37, PROPOSED): the collection safety net
  // (assets/dcg-collection-fallback.js) shows Shopify's own listing of a
  // collection when StorePass's search has nothing for it, or cannot be
  // reached. It needs to know, of every search StorePass's listing makes:
  // that it has started ("dcg:storepass-search-start"), what it answered
  // ("dcg:storepass-search", above), and that it failed
  // ("dcg:storepass-search-failed"): the request was refused by the network,
  // the answer was not a 200, the answer could not be read, or no answer
  // came within 8 seconds (`reason`: network, status, unreadable, timeout).
  // The guard only says so. It decides nothing, and StorePass's own request
  // and answer are neither changed nor delayed. A value-list request
  // (return_type=...) is not a search of the listing and is not announced.
  const SEARCH_PATIENCE = 8000;
  function announceSearchEvent(name, url, extra) {
    try {
      if (!url || !url.searchParams || url.searchParams.get('return_type')) return;
      const query = {};
      url.searchParams.forEach((v, k) => { query[k] = v; });
      const detail = { query: query, isCount: url.searchParams.get('with_count') === 'true' };
      if (extra) Object.keys(extra).forEach(k => { detail[k] = extra[k]; });
      document.dispatchEvent(new CustomEvent(name, { detail: detail }));
    } catch (_) { /* never into StorePass */ }
  }
  // One search, from its start: returns what to call when it is answered or fails.
  function watchSearch(url, patience) {
    let done = false;
    announceSearchEvent('dcg:storepass-search-start', url);
    const timer = setTimeout(() => {
      if (done) return;
      done = true;
      announceSearchEvent('dcg:storepass-search-failed', url, { reason: 'timeout', status: null });
    }, patience || SEARCH_PATIENCE);
    return {
      answered: res => {
        done = true;
        clearTimeout(timer);
        if (!res || !res.ok) announceSearchEvent('dcg:storepass-search-failed', url, { reason: 'status', status: res ? res.status : null });
      },
      failed: () => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        announceSearchEvent('dcg:storepass-search-failed', url, { reason: 'network', status: null });
      },
      // V3.1.2 (item 6): a search the next change overtook (§J): it ends with nothing said; the newer one says it all
      quiet: () => { done = true; clearTimeout(timer); }
    };
  }

  // `res` is a clone; StorePass keeps the original, untouched and undelayed.
  function recordSearchResponse(res, url) {
    // v2-10-4: a 200 whose body is not JSON is a failed search too
    const unreadable = () => { if (res && res.ok) announceSearchEvent('dcg:storepass-search-failed', url, { reason: 'unreadable', status: res.status }); return null; };
    res.json().then(data => data, unreadable).then(data => {
      if (!data || typeof data !== 'object') return;
      [data.products, data.additional_products].forEach(list => {
        if (Array.isArray(list)) list.forEach(recordProduct);
      });
      announceResultTypes(data.products);
      announceSearch(url, data);
      try { if (needsCount(url, data)) completeCount(url); } catch (_) {}   // v2-10-10 (item 1b)
      scheduleDecorate();
    }).catch(() => {});
  }

  // DCG v2-10-10 (item 1; D-SP-38, PROPOSED): StorePass's 14 OCT contract.
  // Since then StorePass's page answer gives count = the products it holds
  // and pages 1, and the whole search is counted only by the same request
  // with with_count=true&no_track=true (docs/REPORT-v2-10-10.md §1). The
  // storepass.js we have sends that request itself beside every page of the
  // listing (not for StorePass's "products_only" grids, nor when a
  // collection's first page comes from Shopify). So the guard asks for the
  // count only when a page answer looks like the page alone (count ==
  // products.length, pages <= 1) and no count request for the same search
  // and page has left: once a search, the answer kept for the page, and
  // announced as a count answer of that page, as storepass.js's own would
  // be, for the count line and the pager (assets/dcg-storepass-paging.js;
  // D-SP-29 unchanged). The page answer itself is never held or changed:
  // storepass.js draws the cards at once. A count call that fails, is not a
  // 200 or has no answer in 8 s was announced as nothing until v2-10-13 (the
  // count line then stood aside, StorePass's own showing); it is now
  // announced as a failed count (below), and the count line puts up the
  // page's own range with Previous / Next and no total (D-SP-29 amended).
  // Never on a value-list search (return_type), never on a search with no
  // sort.
  // DCG v2-10-11 (item 2): and only on a search of the listing's own shape:
  // it names a product line and a collection and asks for the listing's
  // page size (search_limit in the settings storepass.js reads). The
  // header's suggestions (name=…&limit=12&sort=Relevance, with neither)
  // carry a sort, so v2-10-10 counted them, and their pair took over the
  // count line and the pager: "Showing 1-53 of 255" on Advanced Search
  // after "charizard" in the header, "1-60 of 471" on Riftbound after
  // "luffy" (Cowork, 16 OCT 05:50Z).
  const PASSIVE_KEYS = ['page', 'skip', 'with_count', 'no_track', 'shopify_page_parameters'];
  function searchKey(url) {
    const keys = [];
    url.searchParams.forEach((v, k) => { if (PASSIVE_KEYS.indexOf(k) === -1) keys.push(k + '=' + v); });
    return keys.sort().join('&');
  }
  const pageKey = url => searchKey(url) + '|' + (url.searchParams.get('page') || url.searchParams.get('skip') || '1');
  const countsAsked = new Set();         // pageKey of every count request storepass.js sent
  const guardCounts = new Map();         // searchKey -> Promise of the count answer (or null)
  const keep = (store, k) => { if (store.size > 40) store.delete(store.keys().next().value); return k; };
  // the listing's page size, as storepass.js takes it: a limit in the page's address (its own push writes one:
  // limit=60), or else search_limit in the settings it reads (its own default 24 when there is none); null when
  // neither is known yet
  function listingSize() {
    const asked = parseInt(new URLSearchParams(window.location.search).get('limit'), 10);
    if (asked > 0) return asked;
    if (!spSearchSettings) return null;
    const n = parseInt(spSearchSettings.search_limit, 10);
    return n > 0 ? n : 24;
  }
  function listingShaped(url) {
    const p = url.searchParams, size = listingSize();
    return !!p.get('product_line') && !!p.get('shopify_collection_id') && size !== null && parseInt(p.get('limit'), 10) === size;
  }
  function needsCount(url, data) {
    if (!url || !url.searchParams || url.searchParams.get('return_type') || url.searchParams.get('with_count') === 'true') return false;
    if (!url.searchParams.get('sort')) return false;
    if (!listingShaped(url)) return false;                                // v2-10-11 (item 2): never the header's suggestions
    const n = Array.isArray(data.products) ? data.products.length : 0;
    if (!n || data.count !== n || data.pages > 1) return false;          // an exact answer is left alone
    return !countsAsked.has(pageKey(url));                               // storepass.js asked for it itself
  }
  function countCall(href) {
    return new Promise(resolve => {
      let done = false;
      const end = v => { if (!done) { done = true; resolve(v); } };
      setTimeout(() => end(null), SEARCH_PATIENCE);
      let pending;
      try { pending = upstreamFetch.call(window, href); } catch (_) { end(null); return; }
      pending.then(res => (res && res.ok ? res.json() : null)).then(data => {
        end(data && typeof data === 'object' && typeof data.count === 'number' ? data : null);
      }, () => end(null));
    });
  }
  const countUrlOf = url => { const c = new URL(url.href); c.searchParams.set('with_count', 'true'); c.searchParams.set('no_track', 'true'); return c; };
  function completeCount(url) {
    const asked = countUrlOf(url);
    const key = searchKey(url);
    let answer = guardCounts.get(key);
    if (!answer) {
      answer = countCall(asked.href);
      guardCounts.set(keep(guardCounts, key), answer);
      answer.then(a => { if (!a && guardCounts.get(key) === answer) guardCounts.delete(key); });   // a later page may ask again
    }
    // DCG v2-10-13 (item 4b; D-SP-29 amended, LOCKED by Cole, 16 OCT 07:20Z): a count call of the guard's own that
    // fails (no answer in 8 s, not a 200, no count in it) is announced as failed, as storepass.js's own count request
    // is (watchSearch), so the count line puts up "Showing 1-60" with Previous / Next and no total. The safety net
    // takes no failed count for its own: this call leaves only after the page answer has come with products.
    answer.then(a => {
      if (a) announceSearch(asked, { count: a.count, countEstimate: a.countEstimate, pages: a.pages, current_page: a.current_page }, { byGuard: true });
      else announceSearchEvent('dcg:storepass-search-failed', asked, { reason: 'count', status: null, byGuard: true });
    });
  }

  // DCG v2-10-10 (item 1a): the sort, outgoing. StorePass's search takes the
  // sort by its label since the 14 OCT release; the short names fall to its
  // default order. storepass.js sends a label for every sort it chooses
  // itself (its sort control; a collection's own sort_order through its map
  // of names to labels; "Relevance" for a name search), but a sort written
  // in the page's address (?sort=...) goes as it is written. So a short name
  // is sent as its label. Every other value, "Relevance", "Sales",
  // "Recently Added" and every label among them, goes unchanged.
  // DCG v2-10-13 (item 4a; LOCKED by Cole, 16 OCT 07:20Z): created-desc goes as
  // "Recently Added", the label storepass.js's own map gives it (and its sort
  // control and the safety net use), not "Release Date: New-Old" (v2-10-10's).
  const SORT_LABELS = {
    'alpha-asc':    'Alphabetical: A-Z',
    'alpha-desc':   'Alphabetical: Z-A',
    'price-asc':    'Price: Low-High',
    'price-desc':   'Price: High-Low',
    'created-desc': 'Recently Added'
  };
  // DCG v2-10-11 (item 3): in_stock, outgoing, in the same place. storepass.js's
  // own "In Stock Only" link calls its handler with nothing, so its state
  // holds undefined and its request says in_stock=undefined, the word (the
  // plain request and the count request; off, it sends in_stock= empty).
  // StorePass's search takes any value but an empty one as "in stock" (16
  // OCT: Riftbound singles, page 1 under A-Z, the same 60 cards in the same
  // order, all in stock, for "undefined" and for "true"; 31 in stock of 60
  // with it off; docs/img/v2-10-11/in-stock-probe.txt), and a stricter
  // reading would drop the filter without a sign. It leaves as
  // in_stock=true. The theme reads in_stock only from the address and from
  // StorePass's pill, never from the request.
  // DCG V3.1.1 (hotfix.1, F6; Cowork's live phone pass, 20 OCT, noted since 16 OCT): the search went as the label,
  // but storepass.js draws its Sort button from the address as it is written: "?sort=price-desc" read "Sort:
  // price-desc", and the safety net, which knows only the labels, opened on Sales. This file runs just before
  // storepass.js (layout/theme.liquid), so on a listing page a short name in the address is put back as its label
  // here, in place (no history step), before storepass.js reads it: the button, the searches, the net and a shared
  // link then all say "Price: High-Low", as after a pick in StorePass's own menu. Any other value is left as written.
  function labelTheAddress() {
    try {
      if (!document.getElementById('product-listing-container')) return false;
      const url = new URL(window.location.href);
      const sort = url.searchParams.get('sort');
      if (sort === null || !Object.prototype.hasOwnProperty.call(SORT_LABELS, sort)) return false;
      url.searchParams.set('sort', SORT_LABELS[sort]);
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      return true;
    } catch (_) { return false; }
  }
  labelTheAddress();

  // ═════════════════════════════════════════════════════════════════════════
  // §I  IN STOCK ONLY BY DEFAULT, REMEMBERED (DCG V3.1.2, item 1; Cole, 20 OCT;
  //     docs/PROMPT-V3-1-2-adjustments.md)
  // The settings file says in_stock_default: true (a theme-owned key,
  // tools/rebuild-generated.js). storepass.js then opens every listing that is
  // not a products_only grid (collections, /search, Advanced Search) with In
  // Stock Only on, and it applies the setting again each time it re-reads an
  // address that carries no in_stock (the panel's filters, the pager, Back): a
  // visitor who took In Stock Only off had it back on at the next filter
  // (measured on the draft, 20 OCT, tests/skin/instock-default-try.js). So the
  // visitor's choice is kept here, for the visit:
  //   - when a listing's own search goes from in stock to not (StorePass's pill
  //     or the sidebar's switch, off) or back, while the address carries no
  //     in_stock, the choice is written to sessionStorage (dcg_in_stock: "off",
  //     or nothing for on) and into the settings object storepass.js holds, so
  //     its re-reads on this page keep it;
  //   - on every page of the visit the settings object is given the choice as
  //     it is parsed, before storepass.js makes its first search: off stays off
  //     on every listing; a new visit starts on again;
  //   - an address that carries in_stock wins, as storepass.js reads it (true is
  //     on, empty is off), and is not remembered as a choice; "false", "0",
  //     "off" or "no", which storepass.js would send as in stock (its search
  //     takes any value but an empty one as on), are put back as empty here,
  //     in place, before storepass.js reads the address;
  //   - a page can hold In Stock Only off for itself without remembering it:
  //     Advanced Search's All Singles ("show out-of-stock singles too"), read
  //     from that page's own script; stockForPage for any other.
  // storepass.js reads the setting again at moments that are its own, so the
  // setting is made a getter on the object it holds: every read gets the
  // default in force at that moment. A change of the listing's search is a
  // choice only when it goes against that default (a re-read that follows the
  // default, All Singles on or off, is not the visitor's).
  // DCG V3.1.2, the addendum (Cole, 21 OCT): in_stock_default is false again
  // (every product shows, in-stock first: §K), "the visitor's toggle still
  // remembered per session as built". So the visit keeps the visitor's choice
  // whichever way it goes from the file's default: dcg_in_stock "on" (the file
  // off, the visitor turned it on) or "off" (the file on, turned off); nothing
  // while the choice is the file's own. The getter is put on whatever the file
  // says, so a choice of "on" opens the visit's next listings with In Stock Only
  // on (StorePass's own pill then shows: the visitor's chip, D-SP-50).
  // ═════════════════════════════════════════════════════════════════════════
  const STOCK_KEY = 'dcg_in_stock';
  const STOCK_OFF_WORDS = /^(false|0|off|no)$/i;
  let fileStockDefault = null;           // in_stock_default as the settings file has it
  let pageStock = null;                  // a page's own hold (stockForPage), or null
  let lastStock = null;                  // the in-stock state of this page's last listing search, null before the first
  // the visit's choice, where it differs from the file's default: 'on', 'off', or null
  function sessionStock() { try { const v = window.sessionStorage.getItem(STOCK_KEY); return v === 'on' || v === 'off' ? v : null; } catch (_) { return null; } }
  const sessionStockOff = () => sessionStock() === 'off';
  const addressCarriesStock = () => { try { return new URLSearchParams(window.location.search).has('in_stock'); } catch (_) { return false; } };
  // the address's own In Stock Only, where it carries in_stock: on for a value, off for none (or an off word); else null
  const addressStock = () => { try { const p = new URLSearchParams(window.location.search); if (!p.has('in_stock')) return null; const v = p.get('in_stock'); return !!v && !STOCK_OFF_WORDS.test(v); } catch (_) { return null; } };
  // the default in force on this page: the page's own hold (stockForPage, All Singles: off), else the visit's choice,
  // else the file's
  function stockDefaultNow() {
    if (pageStock !== null) return pageStock;
    try { const adv = window.DCG.storepassAdvSearch; if (adv && typeof adv.all === 'function' && adv.all()) return false; } catch (_) {}
    const chosen = sessionStock();
    if (chosen) return chosen === 'on';
    return fileStockDefault === true;
  }
  // the setting, made live on the object storepass.js holds (a plain value where a getter cannot be put); settings that
  // do not name it are left exactly as they are
  function liveStockDefault(ss) {
    fileStockDefault = ss.in_stock_default;
    if (!Object.prototype.hasOwnProperty.call(ss, 'in_stock_default')) return;
    try {
      Object.defineProperty(ss, 'in_stock_default', { configurable: true, enumerable: true, get: stockDefaultNow, set: v => { fileStockDefault = v; } });
    } catch (_) { applyStockDefault(); }
  }
  function applyStockDefault() {
    try {
      if (!spSearchSettings || !Object.prototype.hasOwnProperty.call(spSearchSettings, 'in_stock_default')) return;
      const d = Object.getOwnPropertyDescriptor(spSearchSettings, 'in_stock_default');
      if (!d || !d.get) spSearchSettings.in_stock_default = stockDefaultNow();
    } catch (_) {}
  }
  function stockTheAddress() {
    try {
      if (!document.getElementById('product-listing-container')) return false;
      const url = new URL(window.location.href);
      const v = url.searchParams.get('in_stock');
      if (v === null || !STOCK_OFF_WORDS.test(v)) return false;
      url.searchParams.set('in_stock', '');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      return true;
    } catch (_) { return false; }
  }
  stockTheAddress();
  function rememberStock(on) {
    // the addendum: kept only where it differs from the file's default ("on" with the file off, "off" with it on)
    try { if (!!on === (fileStockDefault === true)) window.sessionStorage.removeItem(STOCK_KEY); else window.sessionStorage.setItem(STOCK_KEY, on ? 'on' : 'off'); } catch (_) {}
    applyStockDefault();
    try { document.dispatchEvent(new CustomEvent('dcg:storepass-stock', { detail: { on: !!on, remembered: true } })); } catch (_) {}
  }
  // (the addendum's gate, 21 OCT: the filters suite on the draft) "Clear all" puts the site's default back: the visit's
  // choice is forgotten. With the file's default off, a visitor's "on" otherwise came straight back: storepass.js's own
  // Clear re-reads an address with no in_stock and takes the default in force, the visit's "on" (the pill and
  // in_stock=true after "Clear all", on every listing the suite read). The filter panel says it before it presses
  // StorePass's Clear (dcg:storepass-cleared: its "Clear all", the phone drawer's Clear); the safety net's "Clear all"
  // calls forgetStock() itself. The address's own in_stock and a page's hold (All Singles) are not the visit's: untouched.
  function forgetStock() {
    try { window.sessionStorage.removeItem(STOCK_KEY); } catch (_) {}
    applyStockDefault();
  }
  try { document.addEventListener('dcg:storepass-cleared', forgetStock); } catch (_) {}
  function stockForPage(on) {
    pageStock = (on === null || on === undefined) ? null : !!on;
    applyStockDefault();
  }
  // A search of the listing itself: a page of cards at the listing's page size, on a page that has a listing (not a
  // count, not a value list, not the panel's own type lookup, not the header's suggestions, not the deck builder)
  function listingSearch(url) {
    try {
      const p = url.searchParams;
      if (!document.getElementById('product-listing-container')) return false;
      if (p.get('return_type') || p.get('with_count') === 'true' || !p.get('product_line')) return false;
      const size = listingSize();
      return size !== null && parseInt(p.get('limit'), 10) === size;
    } catch (_) { return false; }
  }
  function noteStock(url) {
    if (!url || !listingSearch(url)) return;
    const on = !!url.searchParams.get('in_stock');
    if (lastStock !== null && on !== lastStock && !addressCarriesStock() && on !== stockDefaultNow()) rememberStock(on);
    lastStock = on;
  }

  function labelledSearchUrl(input) {
    if (typeof input !== 'string' && !(typeof URL !== 'undefined' && input instanceof URL)) return null;   // a Request object is left alone
    const url = new URL(String(input), window.location.href);
    let changed = false;
    const sort = url.searchParams.get('sort');
    if (sort !== null && Object.prototype.hasOwnProperty.call(SORT_LABELS, sort)) { url.searchParams.set('sort', SORT_LABELS[sort]); changed = true; }
    if (url.searchParams.get('in_stock') === 'undefined') { url.searchParams.set('in_stock', 'true'); changed = true; }
    // V3.1.2 (item 1): an off word leaves as off (empty); storepass.js's search would take it as in stock
    if (STOCK_OFF_WORDS.test(url.searchParams.get('in_stock') || '')) { url.searchParams.set('in_stock', ''); changed = true; }
    // (V3.1.2 round 3, §M) the theme's own parameters on every search of the listing
    try { if (themeParams(url)) changed = true; } catch (_) {}
    return changed ? url.toString() : null;
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §M  THE THEME OWNS THE SEARCH PARAMETERS (DCG V3.1.2 round 3, item 2;
  //     Cole, 21 OCT: "Shouldn't we build into the dashboard in case there are
  //     changes on StorePass's end?"; D-SP-52, PROPOSED)
  // The theme decides what a visitor's search asks; StorePass's dashboard is
  // read by the settings build only, and cannot change it. Read in storepass.js
  // (21 OCT), the dashboard reaches a visitor's search through its settings:
  //   - in_stock_default (in_stock=true on every search), search_limit (the
  //     page size): the theme-owned keys of the settings file (D-SP-25); held
  //     here as well, for StorePass's own settings, which storepass.js reads
  //     when the theme's file fails;
  //   - sort_defaults: the opening sort with no sort given ("default"), and,
  //     for a collection named in "categories", its sort AND its page size;
  //   - product_lines: a line naming a collection's id is sent as that
  //     collection's product_line (since D-SP-49 the dashboard's "Magic: the
  //     Gathering" names magic-the-gathering, so its searches hold the singles
  //     line alone).
  // So, on whatever settings storepass.js parses: sort_defaults becomes
  // { default: "Relevance", categories: [] } (a collection opens on its own
  // sort_order, the theme's: dcg-storepass-settings.json), and
  // dont_use_product_line true (storepass.js then sends "All"). Settings that
  // are not the theme's file (no "dcg" block: StorePass's own, the file having
  // failed) are also given the theme-owned keys, and their collections the
  // theme's opening sort (A to Z; Recently Added and Featured kept, as the
  // settings build keeps them). And every search of the listing (one that
  // carries product_line) leaves with the theme's product line for its
  // collection (dcg.product_lines in the settings file, else "All"), its
  // in_stock said (empty where storepass.js leaves it out, its "off"; its "on"
  // is the default in force, the theme's, §I), and, a page of cards, its sort
  // and its page size where it carries none.
  // Still the dashboard's (inherited, read against tools/generated-diff.js
  // --dashboard each round): the sidebar's groups (include_tag_filter,
  // include_product_type_filter, include_packaging_filter, location_filter,
  // custom filters' order), available_sorts (the Sort menu's names), texts and
  // style, currency and locale, api_base_url, product_item_style (the guard's
  // card check), in_stock_first_for_search_terms (sent with a name search;
  // measured to change no order, 21 OCT).
  // ═════════════════════════════════════════════════════════════════════════
  const THEME_SEARCH = { in_stock_default: false, search_limit: '60', in_stock_first_per_page: false };   // as local-additions.json holds them
  const THEME_SORT_DEFAULT = 'Relevance';
  const SORT_ORDER_LABELS = { 'alpha-asc': 'Alphabetical: A-Z', 'alpha-desc': 'Alphabetical: Z-A', 'best-selling': 'Sales', 'created-desc': 'Recently Added', 'created-asc': 'Oldest', 'price-asc': 'Price: Low-High', 'price-desc': 'Price: High-Low', manual: 'Featured' };
  let settingsFrom = null;               // 'theme' (the theme's file) | 'storepass' (StorePass's own: the file failed)
  let themeOverrode = [];                // the keys of the parsed settings this file set to the theme's
  let parsedCollections = [];            // the collections of the parsed settings: id, sort_order
  function ownSettings(obj, ss) {
    settingsFrom = obj && obj.dcg && typeof obj.dcg === 'object' ? 'theme' : 'storepass';
    const overrode = [];
    const set = (k, v) => { if (JSON.stringify(ss[k]) !== JSON.stringify(v)) overrode.push(k); ss[k] = v; };
    const cols = [].concat((obj.store && obj.store.shopify_smart_collections) || [], (obj.store && obj.store.shopify_custom_collections) || []);
    if (settingsFrom === 'storepass') {
      Object.keys(THEME_SEARCH).forEach(k => set(k, THEME_SEARCH[k]));
      let n = 0;
      cols.forEach(c => { if (c && c.sort_order !== 'created-desc' && c.sort_order !== 'manual' && c.sort_order !== 'alpha-asc') { c.sort_order = 'alpha-asc'; n++; } });
      if (n) overrode.push('collections\' sort_order (' + n + ')');
    }
    set('sort_defaults', { default: THEME_SORT_DEFAULT, categories: [] });
    set('dont_use_product_line', true);
    themeOverrode = overrode;
    parsedCollections = cols.filter(c => c && c.id).map(c => ({ id: String(c.id), sort_order: c.sort_order }));
  }
  const themeLineFor = c => { const m = dcgFile && dcgFile.product_lines; return (m && c && typeof m[String(c)] === 'string' && m[String(c)]) || 'All'; };
  function themeOpeningSort(p) {
    if (p.get('name') || /^\/search\/?$/.test(window.location.pathname)) return THEME_SORT_DEFAULT;
    const c = parsedCollections.find(x => x.id === String(p.get('shopify_collection_id') || ''));
    return (c && SORT_ORDER_LABELS[c.sort_order]) || 'Alphabetical: A-Z';
  }
  const themePageSize = () => { const n = parseInt(spSearchSettings && spSearchSettings.search_limit, 10); return n > 0 ? n : parseInt(THEME_SEARCH.search_limit, 10); };
  // a search of the listing: storepass.js's page, count or value list (it carries product_line), on a listing page
  function themeParams(url) {
    const p = url.searchParams;
    if (!p.has('product_line') || !document.getElementById(LISTING_ID)) return false;
    let changed = false;
    const line = themeLineFor(p.get('shopify_collection_id'));
    if (p.get('product_line') !== line) { p.set('product_line', line); changed = true; }
    // storepass.js leaves in_stock out for "off" (its pill's x, its link): said as such, empty. (Its "on" comes from the
    // default in force, the theme's: §I's getter; the address's own in_stock goes as it is)
    if (!p.has('in_stock')) { p.set('in_stock', ''); changed = true; }
    if (!p.get('return_type') && p.get('with_count') !== 'true') {
      if (!p.get('sort')) { p.set('sort', themeOpeningSort(p)); changed = true; }
      if (!p.get('limit')) { p.set('limit', String(themePageSize())); changed = true; }
    }
    return changed;
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §K  IN STOCK FIRST ACROSS THE WHOLE LISTING (DCG V3.1.2, the addendum:
  //     item 1 amended; Cole, 21 OCT; docs/PROMPT-V3-1-2-addendum-in-stock-first.md)
  // In Stock Only is off by default again: every product shows, the in-stock
  // ones first and the out-of-stock ones after, across the whole listing
  // (in_stock_first_per_page put them first within one page only: page 1
  // could end with sold-out cards while page 2 opened with in-stock ones).
  // Cole's rule (the addendum's table; it keys on the listing's kind, not on
  // the engine, so the safety net follows it too, dcg-collection-fallback.js):
  //   - a singles listing (a singles collection, /search, Advanced Search):
  //     in-stock first under every sort but "Price: High-Low" and "Price:
  //     Low-High", where price wins and stock is ignored (In Stock Only is the
  //     visitor's toggle). No listing opens on a price sort (the settings
  //     file's sort_orders are A-Z, Recently Added and Featured; /search opens
  //     on Relevance, Advanced Search on A-Z), so a price sort is always the
  //     visitor's: the address's or the Sort menu's;
  //   - every other collection: in-stock first under every sort, price too.
  //   The sort holds within each part.
  // How. A page of the listing that storepass.js asks for with In Stock Only
  // off is answered here from two of StorePass's searches under its sort:
  // the listing in stock (in_stock=true), whose pages come first, then the
  // rest of the listing. StorePass has no search for the out-of-stock
  // products alone (21 OCT: no spelling of in_stock, nor any other key tried,
  // returns flesh-and-blood-sealed-product's 64 out of stock; each returns all
  // 102 or the 38 in stock), so the rest is the listing's own search read
  // page by page from its start, its in-stock products left out (a product
  // with stock above 0 is in stock: the 38 of the 102 there, as StorePass's
  // in_stock=true counts them). So:
  //   - a page inside the in-stock part: that page of the in-stock search;
  //   - the seam (the in-stock search's page comes back short): its
  //     products, then the first out-of-stock ones;
  //   - a page after it: the out-of-stock products at its offset, from the
  //     in-stock part's size (its count where StorePass's is exact, under
  //     1,000; else its last page, found by asking for pages).
  //   A listing none of which is out of stock (every singles collection, 21
  //   OCT: StorePass holds their in-stock products only) is known at its last
  //   page by one request: its whole search's page there ends where the
  //   in-stock part does.
  // The address stays ?page=N, and the answer is storepass.js's own page
  // answer in shape (it counts only itself, as StorePass's does since its 14
  // OCT release), so its count request, the count line, the pager and the
  // safety net read it as before. Each of these searches is asked once (pages
  // kept 2 minutes, counts 5); a stitched search the next change overtakes is
  // cancelled with its own (§J). Anything that fails on the way: the search
  // goes as storepass.js asked it (its own order).
  // The in-stock count is asked once a listing (none when a short in-stock
  // page has said it) and announced for the count line ("Showing 1-60 of
  // 1,943 · 1,120 in stock", assets/dcg-storepass-paging.js), under the two
  // price sorts too. Not touched: In Stock Only on (the listing is its
  // in-stock part alone), a search by product ids, a skip= search, the
  // header's suggestions, a products_only grid, and an answer of Shopify's own
  // cursor pages (StorePass's dashboard switch "Use Shopify for initial
  // collection results"): those go as they came. The settings file can turn
  // it off: "dcg": { "in_stock_first": false }.
  // ═════════════════════════════════════════════════════════════════════════
  const STITCH_TTL = { page: 120000, count: 300000 };
  const STITCH_KEEP = 80;                // searches kept
  const STITCH_SCAN = 3;                 // pages of the whole listing read at once, at most, for its out-of-stock part
  // (V3.1.2 round 3, Cole, 22 OCT: docs/PROMPT-V3-1-2-round-3-weight-and-dashboard.md, item 1) the whole listing is read
  // at the page size for its out-of-stock part, and only where the in-stock part does not fill the page. Read 250 at a
  // time (the addendum) it cost /search's first visit 1.7 MB (StorePass's answers are uncompressed, about 7 KB a
  // product). StorePass's ties can move a card across a page's edge from one request to the next: a card twice is
  // dropped by its id, and a card already drawn on another page of this visit's listing stays on that page (the drawn
  // map below, sessionStorage, one listing and sort at a time); a page the drop leaves short is filled once.
  // Is any of the listing out of stock? Asked at the seam by one page of the whole search only when the in-stock part
  // is ten pages or more (else the reads themselves say it, without that request)
  const NONE_CHECK_PAGES = 10;
  const STITCH_MAX = 10000;              // StorePass serves nothing past about 10,000 results
  const PRICE_SORTED = /^Price:/i;
  let dcgFile = null;                    // the settings file's own block ("dcg"), read with its settings (keepSettings)
  const stitchOn = () => !(dcgFile && dcgFile.in_stock_first === false);
  const singlesHandle = h => /(^|-)singles?(-|$)/i.test(String(h || ''));
  // a singles listing: Advanced Search, the search results, a singles collection (its handle says so)
  function singlesListing() {
    try {
      const root = document.getElementById(LISTING_ID);
      if (!root) return false;
      if (root.hasAttribute('data-dcg-adv')) return true;
      if (/^\/search\/?$/.test(window.location.pathname)) return true;
      return singlesHandle(root.getAttribute('data-dcg-collection-handle'));
    } catch (_) { return false; }
  }
  const priceWins = url => PRICE_SORTED.test(url.searchParams.get('sort') || '') && singlesListing();
  // (the addendum's gate, 21 OCT) a collection in stock only by Shopify's own rule (every rule to hold, one of them
  // "variant inventory greater than 0": the singles collections, 29 of them; the settings file's dcg.in_stock_only, built
  // from StorePass's response before its rules are taken off): nothing in it to put after, so neither the two searches
  // nor the in-stock count (on the draft, each filter there cost the in-stock count and, on a short page, a read of the
  // whole listing, for nothing)
  function inStockOnlyListing(url) {
    try {
      const ids = dcgFile && Array.isArray(dcgFile.in_stock_only) ? dcgFile.in_stock_only : null;
      const c = url.searchParams.get('shopify_collection_id');
      return !!(ids && c && ids.indexOf(String(c)) !== -1);
    } catch (_) { return false; }
  }
  // the listing's own page, In Stock Only off, to be answered in-stock first
  function stitchable(url) {
    try {
      if (!stitchOn() || !url || !listingSearch(url)) return false;
      const p = url.searchParams;
      if (p.get('in_stock') || p.get('product_ids') || p.get('product_handles') || parseInt(p.get('skip'), 10) > 0) return false;
      if (inStockOnlyListing(url)) return false;
      return !priceWins(url);
    } catch (_) { return false; }
  }
  // in stock as StorePass's in_stock=true counts it: stock above 0
  function stockedProduct(p) {
    if (!p || typeof p !== 'object') return false;
    const n = parseInt(p.stock !== undefined && p.stock !== null && p.stock !== '' ? p.stock : p.totalInventory, 10);
    return !isNaN(n) && n > 0;
  }
  function variantUrl(url, set) {
    const u = new URL(url.href);
    Object.keys(set).forEach(k => { if (set[k] === null) u.searchParams.delete(k); else u.searchParams.set(k, set[k]); });
    return u;
  }
  const pageUrl = (url, n) => variantUrl(url, { page: String(n), skip: null });
  const inStockUrl = url => variantUrl(url, { in_stock: 'true' });
  const stockKeyOf = url => searchKey(variantUrl(url, { sort: null, in_stock: 'true' }));      // the in-stock part's size is the same under every sort
  function abortError() { try { return new DOMException('The operation was aborted.', 'AbortError'); } catch (_) { const e = new Error('The operation was aborted.'); e.name = 'AbortError'; return e; } }

  // One of StorePass's searches, asked once: every caller waiting on it is given its answer. A caller's own signal ends
  // its wait; the request itself is cancelled when every caller that had a signal has let it go.
  const stitchSubs = new Map();          // href -> { at, kind, ctl, done, holders, promise }
  function subAsk(href, kind, signal) {
    if (signal && signal.aborted) return Promise.reject(abortError());
    let e = stitchSubs.get(href);
    if (e && e.done && Date.now() - e.at > STITCH_TTL[kind]) { stitchSubs.delete(href); e = null; }
    if (!e) {
      const ctl = typeof AbortController === 'function' ? new AbortController() : null;
      const entry = { at: Date.now(), kind, ctl, done: false, holders: 0, promise: null };
      let pending;
      try { pending = upstreamFetch.call(window, href, ctl ? { signal: ctl.signal } : undefined); } catch (err) { pending = Promise.reject(err); }
      entry.promise = pending
        .then(r => { if (!r || !r.ok) throw new Error('StorePass answered ' + (r ? r.status : 'nothing')); return r.json(); })
        .then(d => { if (!d || typeof d !== 'object') throw new Error('unreadable'); entry.done = true; entry.at = Date.now(); return d; });
      entry.promise.catch(() => { if (stitchSubs.get(href) === entry) stitchSubs.delete(href); });
      stitchSubs.set(href, entry);
      while (stitchSubs.size > STITCH_KEEP) stitchSubs.delete(stitchSubs.keys().next().value);
      e = entry;
    }
    const entry = e;
    if (!entry.done) entry.holders += signal ? 1 : 1000;          // a caller with no signal never lets it go
    if (!signal) return entry.promise;
    return new Promise((resolve, reject) => {
      let over = false;
      const gone = () => {
        if (over) return;
        over = true;
        if (!entry.done && --entry.holders <= 0 && entry.ctl) { try { entry.ctl.abort(); } catch (_) {} }
        reject(abortError());
      };
      signal.addEventListener('abort', gone, { once: true });
      entry.promise.then(d => { over = true; signal.removeEventListener('abort', gone); resolve(d); },
                         err => { over = true; signal.removeEventListener('abort', gone); reject(err); });
    });
  }

  // The in-stock part's size: once known for a listing, the same under every sort and on every page
  const inStockCounts = new Map();       // stockKey -> { count, estimate, exact }
  // (round 3) kept for the visit too, 5 minutes (a count's time, §J), so the next page load of the listing does not ask
  // it again: sessionStorage dcg_instock_counts { stockKey: { c, at } }
  const COUNTS_KEY = 'dcg_instock_counts';
  function storedCounts() { try { const m = JSON.parse(window.sessionStorage.getItem(COUNTS_KEY) || '{}'); return m && typeof m === 'object' ? m : {}; } catch (_) { return {}; } }
  function storedCount(key) { const e = storedCounts()[key]; return e && e.c && Date.now() - e.at < STITCH_TTL.count ? e.c : null; }
  function keepCount(key, c) {
    inStockCounts.set(key, c); while (inStockCounts.size > 40) inStockCounts.delete(inStockCounts.keys().next().value);
    try {
      const m = storedCounts(); m[key] = { c, at: Date.now() };
      const keys = Object.keys(m).sort((a, b) => m[b].at - m[a].at); keys.slice(20).forEach(k => delete m[k]);
      window.sessionStorage.setItem(COUNTS_KEY, JSON.stringify(m));
    } catch (_) {}
  }
  function sayInStock(url, c) {
    try {
      const query = {};
      url.searchParams.forEach((v, k) => { query[k] = v; });
      document.dispatchEvent(new CustomEvent('dcg:storepass-instock', { detail: { query: query, count: c ? c.count : null, estimate: c ? c.estimate : null, exact: !!(c && c.exact) } }));
    } catch (_) { /* never into StorePass */ }
  }
  // StorePass's count of the listing in stock (with_count=true&in_stock=true): exact under 1,000, an estimate above. Asked
  // once a listing, whatever the sort (a second sort's search waits on the first's count)
  const inStockAsks = new Map();         // stockKey -> the count on its way
  function inStockCount(url) {
    const key = stockKeyOf(url);
    const known = inStockCounts.get(key);
    if (known) return Promise.resolve(known);
    const kept = storedCount(key);
    if (kept) { inStockCounts.set(key, kept); return Promise.resolve(kept); }
    if (inStockAsks.has(key)) return inStockAsks.get(key);
    const asking = subAsk(countUrlOf(variantUrl(inStockUrl(url), { page: null, skip: null })).href, 'count', null).then(d => {
      if (typeof d.count !== 'number') return null;
      const estimate = d.countEstimate === undefined || d.countEstimate === null ? null : String(d.countEstimate);
      const exact = estimate === null ? d.count < 1000 : (estimate.indexOf('+') === -1 && parseInt(estimate.replace(/[^\d]/g, ''), 10) === d.count);
      if (!inStockCounts.has(key) || !inStockCounts.get(key).exact) keepCount(key, { count: d.count, estimate: estimate, exact: exact });
      return inStockCounts.get(key);
    });
    inStockAsks.set(key, asking);
    const done = () => { if (inStockAsks.get(key) === asking) inStockAsks.delete(key); };
    asking.then(done, done);
    return asking;
  }
  // the in-stock part's size, read from a short page of its search: exact
  function knownInStock(url, k) { keepCount(stockKeyOf(url), { count: k, estimate: null, exact: true, fromPage: true }); }
  // the line's number, for a listing search with In Stock Only off (both kinds: in-stock first, and price)
  function noteInStock(url) {
    try {
      if (!stitchOn() || !url || !listingSearch(url) || url.searchParams.get('in_stock') || url.searchParams.get('product_ids')) return;
      if (inStockOnlyListing(url)) return;              // every product in stock: the line's total says it
      inStockCount(url).then(c => sayInStock(url, c), () => sayInStock(url, null));
    } catch (_) {}
  }

  // the in-stock part's size, exactly, for a page past it
  async function seamOf(url, S, signal) {
    const c = await inStockCount(url).catch(() => null);
    if (signal && signal.aborted) throw abortError();
    if (c && c.exact) return c.count;
    // an estimate (StorePass's count above 1,000: below the real number) or none: its search's last page, found by
    // asking for pages (doubling, then halving between a full page and an empty one)
    const key = stockKeyOf(url);
    const most = Math.ceil(STITCH_MAX / S);
    let lo = 0, hi = most + 1;            // lo: the last page known full (0: none yet); hi: the first page known empty
    let g = c && c.count > 0 ? Math.min(most, Math.max(1, Math.ceil(c.count / S))) : 1;
    for (let tries = 0; tries < 20; tries++) {
      const d = await subAsk(pageUrl(inStockUrl(url), g).href, 'page', signal);
      const n = Array.isArray(d.products) ? d.products.length : 0;
      if (n > 0 && n < S) { const k = (g - 1) * S + n; knownInStock(url, k); return k; }
      if (n >= S) lo = g; else hi = g;
      if (hi - lo <= 1) { const k = Math.min(lo, most) * S; keepCount(key, { count: k, estimate: null, exact: true, fromPage: true }); return k; }
      g = hi > most ? Math.min(most, lo * 2) : Math.floor((lo + hi) / 2);
      if (g <= lo) g = lo + 1;
    }
    throw new Error('the in-stock part\'s end was not found');
  }

  // The out-of-stock part, in the listing's order: its whole search's pages read from the start, in-stock products left out
  const streams = new Map();             // searchKey of the whole search -> { items, ids, read, done, none, at }
  async function outOfStock(url, S, K, from, need, signal) {
    const key = searchKey(url);
    let st = streams.get(key);
    if (st && Date.now() - st.at > STITCH_TTL.page) { streams.delete(key); st = null; }
    if (!st) {
      st = { items: [], ids: new Set(), read: 0, done: false, none: null, at: Date.now() };
      streams.set(key, st);
      while (streams.size > 12) streams.delete(streams.keys().next().value);
    }
    const L = S;                          // (round 3) at the page size
    // (round 3) none out of stock, said by storepass.js's own count of the whole search (sent with its page, held by
    // §J): no request of this file's. Its count exact and equal to the in-stock part: nothing to read
    if (st.none === null) {
      const whole = await wholeCountOf(url);
      if (whole !== null && whole === K) { st.none = true; st.done = true; }
    }
    const scanUrl = n => variantUrl(url, { page: String(n), skip: null, limit: String(L) });
    if (st.none === null && K >= NONE_CHECK_PAGES * S) {
      // is any of it out of stock? Its whole search's page at the seam ends where the in-stock part does when none is
      // (a smaller in-stock part: the reads below say it)
      const at = Math.floor(K / S) + 1;
      const d = await subAsk(pageUrl(url, at).href, 'page', signal);
      st.none = (Array.isArray(d.products) ? d.products.length : 0) === K - (at - 1) * S;
      if (st.none) st.done = true;
    }
    const most = Math.ceil(STITCH_MAX / L);
    while (!st.done && st.items.length < from + need && st.read < most) {
      // as many pages as the out-of-stock products found so far say are wanted (a full page each, before the first)
      const per = st.read ? Math.max(1, st.items.length / st.read) : L;
      const want = Math.min(STITCH_SCAN, Math.max(1, Math.ceil((from + need - st.items.length) / per)));
      const pages = [];
      for (let i = 1; i <= want && st.read + i <= most; i++) pages.push(st.read + i);
      const answers = await Promise.all(pages.map(n => subAsk(scanUrl(n).href, 'page', signal)));
      for (let i = 0; i < answers.length; i++) {
        const list = Array.isArray(answers[i].products) ? answers[i].products : [];
        list.forEach(p => { const id = productKey(p); if (!stockedProduct(p) && !st.ids.has(id)) { st.ids.add(id); st.items.push(p); } });
        st.read = pages[i];
        if (list.length < L) { st.done = true; break; }
      }
    }
    if (st.none === null && st.done) st.none = st.items.length === 0;
    return st.items.slice(from, from + need);
  }

  // Shopify's own cursor pages (collectionCapabilities.filtering false; nextPageParameters.page_info): not stitched
  const cursorAnswer = d => !!((d.collectionCapabilities && d.collectionCapabilities.filtering === false) || (d.nextPageParameters && d.nextPageParameters.page_info));
  function answerOf(first, products, P, part) {
    const d = {};
    Object.keys(first).forEach(k => { d[k] = first[k]; });
    d.products = products;
    if (Array.isArray(d.additional_products)) d.additional_products = [];
    d.count = products.length;
    d.pages = 1;
    d.current_page = P;
    d.dcg_in_stock_first = part;           // for checking: { inStock, outOfStock, seam, none }
    return new Response(JSON.stringify(d), { status: 200, headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }
  // (round 3) storepass.js's own count of this search, where §J holds it (asked or on its way): exact, or null
  async function wholeCountOf(url) {
    try {
      const e = searches.get(oneSearchKey(countUrlOf(url)));
      if (!e || !e.res) return null;
      const r = await Promise.race([e.res, new Promise(done => setTimeout(() => done(null), 4000))]);
      if (!r || !r.ok) return null;
      const d = await r.clone().json();
      if (!d || typeof d.count !== 'number') return null;
      const est = d.countEstimate === undefined || d.countEstimate === null ? null : String(d.countEstimate);
      const exact = est === null ? d.count < 1000 : (est.indexOf('+') === -1 && parseInt(est.replace(/[^\d]/g, ''), 10) === d.count);
      return exact ? d.count : null;
    } catch (_) { return null; }
  }
  // (round 3) the cards drawn on each page of this visit's listing (one listing and sort at a time: a new search, a new
  // map), so a card StorePass's ties move from one page to another between two requests stays on the page it was
  // drawn on first. Kept 30 minutes. sessionStorage dcg_drawn: { key, at, pages: { id: page } }
  const DRAWN_KEY = 'dcg_drawn', DRAWN_TTL = 30 * 60000;
  const drawnKeyOf = url => searchKey(variantUrl(url, { page: null, skip: null }));
  function drawnOf(url) {
    try {
      const d = JSON.parse(window.sessionStorage.getItem(DRAWN_KEY) || 'null');
      if (d && d.key === drawnKeyOf(url) && Date.now() - d.at < DRAWN_TTL && d.pages && typeof d.pages === 'object') return d.pages;
    } catch (_) {}
    return {};
  }
  function noteDrawn(url, P, list) {
    try {
      const key = drawnKeyOf(url), pages = drawnOf(url);
      list.forEach(p => { const id = productKey(p); if (id && pages[id] === undefined) pages[id] = P; });
      window.sessionStorage.setItem(DRAWN_KEY, JSON.stringify({ key, at: Date.now(), pages }));
    } catch (_) {}
  }
  // a card for page P: not drawn on another page of this visit's listing, not twice on this one
  function freshFor(P, drawn, taken) {
    return p => { const id = productKey(p); if (!id || taken.has(id)) return false; const at = drawn[id]; if (at !== undefined && at !== P) return false; taken.add(id); return true; };
  }
  async function stitch(url, signal) {
    const S = parseInt(url.searchParams.get('limit'), 10);
    const P = Math.max(1, parseInt(url.searchParams.get('page'), 10) || 1);
    const first = await subAsk(pageUrl(inStockUrl(url), P).href, 'page', signal);
    if (cursorAnswer(first)) throw new Error('cursor');
    const got = Array.isArray(first.products) ? first.products : [];
    const drawn = drawnOf(url), taken = new Set();
    const ins = got.filter(freshFor(P, drawn, taken));
    if (got.length >= S) {
      // a page wholly in stock: no out-of-stock read. One the drop left short is filled once from the next in-stock page
      let page = ins.slice(0, S), filled = false;
      if (page.length < S) {
        const next = await subAsk(pageUrl(inStockUrl(url), P + 1).href, 'page', signal);
        const more = (Array.isArray(next.products) ? next.products : []).filter(freshFor(P, drawn, taken));
        page = page.concat(more.slice(0, S - page.length));
        filled = true;
      }
      noteInStock(url);
      noteDrawn(url, P, page);
      return answerOf(first, page, P, { inStock: page.length, outOfStock: 0, seam: false, filled });
    }
    let K, from, need;
    if (got.length > 0 || P === 1) { K = (P - 1) * S + got.length; from = 0; need = S - ins.length; knownInStock(url, K); sayInStock(url, inStockCounts.get(stockKeyOf(url))); }
    else {
      K = await seamOf(url, S, signal);
      sayInStock(url, inStockCounts.get(stockKeyOf(url)) || null);
      from = (P - 1) * S - K; need = S;
      if (from < 0) return answerOf(first, [], P, { inStock: 0, outOfStock: 0, seam: false });   // StorePass served nothing there
    }
    let outs = (await outOfStock(url, S, K, from, need, signal)).filter(freshFor(P, drawn, taken));
    // the drop left the page short while the listing holds more: the next ones of the out-of-stock part, once
    let filled = false;
    if (outs.length < need) {
      const st0 = streams.get(searchKey(url));
      if (!(st0 && st0.done && st0.items.length <= from + need)) {
        const more = (await outOfStock(url, S, K, from + need, need, signal)).filter(freshFor(P, drawn, taken));
        outs = outs.concat(more.slice(0, need - outs.length));
        filled = true;
      }
    }
    const st = streams.get(searchKey(url));
    noteDrawn(url, P, ins.concat(outs));
    return answerOf(first, ins.concat(outs), P, { inStock: ins.length, outOfStock: outs.length, seam: ins.length > 0, none: !!(st && st.none), filled });
  }
  // the page storepass.js asked for, in-stock first; anything that fails on the way: its own search as it asked it
  function stitched(args, url, signal) {
    return stitch(url, signal).catch(err => {
      if ((signal && signal.aborted) || (err && err.name === 'AbortError')) throw err;
      lastStitchFault = String((err && err.message) || err);
      const opts = Object.assign({}, args[1] || {});
      if (signal) opts.signal = signal;
      return upstreamFetch.call(window, args[0], opts);
    });
  }
  let lastStitchFault = null;

  // ═════════════════════════════════════════════════════════════════════════
  // §L  THE TAGS FACET SHOWS THE TAG GROUPS THE THEME NAMES (DCG V3.1.2, the
  //     addendum: D-SP-49, decided by Cole, 21 OCT)
  // StorePass's dashboard draws a "Tag" group in every listing's column
  // (include_tag_filter; Cole: the dashboard's state taken as intended). Its
  // values are every tag of the listing's products: StorePass's own
  // "Group_Value" tags (Printing_Foil, Rarity_Common, Number_001/003; Cole:
  // "StorePass adds new tags on its own; it is something to watch") and the
  // bare tags of BinderPOS and Shopify (set names, "retail", "limit-five").
  // "The filters' Tags facet shows only the tag groups the theme names
  // (dcg-storepass-settings.json's whitelist), never a group StorePass added
  // unannounced, so a new group is reported before it is shown": the group's
  // value list (return_type=custom_filter&custom_filter_key=tags) is given the
  // values of the groups the settings file names in dcg.tag_groups (a tag's
  // group is its word before "_"; "(no group)" names the bare tags); a group the
  // file does not name is held back until it is named there, and
  // tools/generated-diff.js --dashboard says it in every round's end gates.
  // With no list in hand (StorePass's own settings answered in the file's
  // place) no group of StorePass's is given, the bare tags are. An empty list
  // asks StorePass nothing. The safety net's own Tags facet (Shopify's
  // filter.p.tag) follows the same list (tagGroups(), tagShown(), below).
  // ═════════════════════════════════════════════════════════════════════════
  const NO_TAG_GROUP = '(no group)';
  const tagGroupOf = code => { const s = String(code || ''); const i = s.indexOf('_'); return i > 0 ? s.slice(0, i) : NO_TAG_GROUP; };
  const tagGroups = () => (dcgFile && Array.isArray(dcgFile.tag_groups) ? dcgFile.tag_groups.map(String) : null);
  function tagShown(code) {
    const named = tagGroups();
    return named ? named.indexOf(tagGroupOf(code)) !== -1 : tagGroupOf(code) === NO_TAG_GROUP;
  }
  const tagValueList = url => !!(url && url.searchParams && url.searchParams.get('return_type') === 'custom_filter' && url.searchParams.get('custom_filter_key') === 'tags');
  const tagsHeld = { lists: 0, held: 0, groups: {} };
  // (the end gates, 21 OCT: the Tag group drawn empty on tcg-supplies, its 25 tags all without a group) how many values
  // the Tag group is given, said as for StorePass's other groups ('dcg:storepass-facet'; §J's announceFacet leaves this
  // list to here): after the whitelist, so the panel hides a Tag group left with one value or none, as it hides Product
  // Type's one value (dcg-storepass-filters.js). storepass.js asks for the values when the group is opened or the
  // listing changes, not at its load (measured on the draft, tests/skin/tag-timing-probe.js): it is hidden from then.
  function announceTags(url, n) {
    try {
      const p = url.searchParams;
      document.dispatchEvent(new CustomEvent('dcg:storepass-facet', { detail: { key: 'tags', values: n, narrowed: narrowed(url), collection: p.get('shopify_collection_id') || '' } }));
    } catch (_) {}
  }
  function shownTags(res, url) {
    if (!res || !res.ok) return Promise.resolve(res);
    return res.clone().json().then(data => {
      if (!data || !Array.isArray(data.products)) return res;
      tagsHeld.lists++;
      const kept = data.products.filter(v => {
        const code = v && (v.code || v.name);
        if (tagShown(code)) return true;
        tagsHeld.held++;
        const g = tagGroupOf(code);
        tagsHeld.groups[g] = (tagsHeld.groups[g] || 0) + 1;
        return false;
      });
      if (url) announceTags(url, kept.length);
      if (kept.length === data.products.length) return res;
      const out = {};
      Object.keys(data).forEach(k => { out[k] = data[k]; });
      out.products = kept;
      return new Response(JSON.stringify(out), { status: res.status, headers: { 'Content-Type': 'application/json; charset=utf-8' } });
    }, () => res);
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §B  CARD DECORATION
  // Port of dcg-product-card.js BRANCH 1 (retail), BRANCH 2 (coming soon) and
  // step 3b (Retail Only image badge) onto StorePass's card. Controls are
  // hidden, never removed, and every inserted node carries NODE_ATTR, so a
  // pass over an already-decorated card changes nothing.
  // ═════════════════════════════════════════════════════════════════════════

  // Click-time overrides: handle → Shopify's product, set by §C when a click
  // finds Shopify calls a product retail or coming-soon and StorePass's index
  // doesn't say the same, or (D-SP-14) Shopify prices the clicked variant at
  // $0.00 and the index doesn't. Decoration reads this list first, then the
  // tag map, so that card gets its notice at once and keeps it through
  // re-renders and new search responses. The tag map itself is never written
  // with it.
  const clickOverrides = new Map();

  function productForCard(handle) {
    return clickOverrides.get(handle) || productsByHandle.get(handle) || null;
  }

  function hideControls(card, selector) {
    card.querySelectorAll(selector).forEach(el => {
      if (el.hasAttribute(HIDDEN_ATTR) && el.style.display === 'none') return;
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute(HIDDEN_ATTR, '');
    });
  }

  // Undo everything this file did to a card (product behind the node changed,
  // or its tags no longer call for a notice).
  function clearCard(card) {
    if (!card.hasAttribute(STATE_ATTR)) return;
    card.querySelectorAll('[' + NODE_ATTR + ']').forEach(el => {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    card.querySelectorAll('[' + HIDDEN_ATTR + ']').forEach(el => {
      el.style.removeProperty('display');
      el.removeAttribute(HIDDEN_ATTR);
    });
    card.removeAttribute(STATE_ATTR);
    card.removeAttribute(HANDLE_ATTR);
  }

  // Notices take the add-to-cart button's place: directly after it when the
  // card has one, otherwise at the end of the info column.
  function placeInCard(card, node) {
    const cta = card.querySelector(CTA_SELECTOR);
    if (cta && cta.parentNode) {
      cta.parentNode.insertBefore(node, cta.nextSibling);
    } else {
      (card.querySelector(INFO_SELECTOR) || card).appendChild(node);
    }
  }

  // ── Retail Only badge (dcg-product-card.js step 3b, :225-236) ─────────────
  // On the image of every card whose product has the `retail` tag, which is
  // every card in a retail state here (ruleState). Its rule is copied into
  // dcg-storepass.css.
  function addRetailBadge(card) {
    const media = card.querySelector(MEDIA_SELECTOR);
    if (!media || media.querySelector('.dcg-retail-badge')) return;
    const rb = document.createElement('div');
    rb.className = 'dcg-retail-badge';
    rb.setAttribute(NODE_ATTR, '');
    rb.textContent = 'Retail Only';
    media.appendChild(rb);
  }

  // ── BRANCH 1: Retail — always wins, cart always disabled ──────────────────
  // DCG v2-10-13 (item 3; Cole, 16 OCT, §8 14:00Z: "Register in store · Contact us" on event cards everywhere;
  // non-event retail products keep "In-store only · Contact us"): an event is a product tagged event-ticket or whose
  // type is "Events" / "Events - <game>" (docs/EVENTS-DATA-CONTRACT.md; every product of the events collection is
  // one). dcg-product-card.js tells it the same way.
  function isEvent(product) {
    if (!product) return false;
    const tags = Array.isArray(product.tags) ? product.tags : normaliseTags(product.tags) || [];
    if (tags.some(t => String(t).toLowerCase() === 'event-ticket')) return true;
    return /^events?\b/i.test(String(product.productType || product.product_type || product.type || '').trim());
  }
  function addRetailNotice(card, state, product) {
    if (card.querySelector('.dcg-retail-notice[' + NODE_ATTR + ']')) return;

    const retailNotice = document.createElement('div');
    retailNotice.className = 'dcg-retail-notice';
    retailNotice.setAttribute(NODE_ATTR, '');
    retailNotice.innerHTML =
      '<span class="dcg-retail-notice__text">' +
        (state === 'retail-preorder' ? 'Pre-order in-store' : isEvent(product) ? 'Register in store' : 'In-store only') +
      '</span>' +
      '<a href="/pages/contact" class="dcg-retail-notice__link">Contact us &rarr;</a>';

    placeInCard(card, retailNotice);
  }

  // ── Price pending (D-SP-14) ───────────────────────────────────────────────
  // The variant the card has selected, as a string id, or null if it can't
  // be told. StorePass draws the <select> only for products with more than
  // one variant; each option's value is the variant as JSON (storepass.js:
  // value: JSON.stringify(variant)). The select is uncontrolled, so its DOM
  // value is the customer's current choice.
  function selectedVariantId(card, product) {
    let id = null;
    const select = card.querySelector(SELECT_SELECTOR);
    if (select) {
      try {
        const variant = JSON.parse(select.value);
        if (variant && variant.id != null) id = String(variant.id);
      } catch (_) { /* not the markup this file was written for */ }
    } else if (product.variantIds.size === 1) {
      id = product.variantIds.values().next().value;
    }
    // A node React is re-using for another product can still hold the old
    // product's selection for a moment: only trust an id that belongs here.
    return (id && product.variantIds.has(id)) ? id : null;
  }

  function selectedVariantPricePending(card, product) {
    const id = selectedVariantId(card, product);
    if (!id || !product.variantPrices) return false;
    const cents = product.variantPrices.get(id);
    return typeof cents === 'number' && pricePending(cents, product.tags);
  }

  // Takes the place of the add-to-cart button and the quantity stepper.
  function addPriceNotice(card) {
    if (card.querySelector('.dcg-price-notice[' + NODE_ATTR + ']')) return;
    const priceNotice = document.createElement('div');
    priceNotice.className = 'dcg-price-notice';
    priceNotice.setAttribute(NODE_ATTR, '');
    priceNotice.innerHTML = '<span class="dcg-price-notice__text">Price pending</span>';
    placeInCard(card, priceNotice);
  }

  // DCG V3.1.0 (item 0; D-SP-41 amended, LOCKED): the wishlist heart's builder (buildWishlistWrap), its cookie
  // helpers, restoreWishlist and its click handler lived here. No card carries a heart now; the product page's own
  // Add To Wishlist (snippets/wishlist-product.liquid, shop.js) and /pages/wishlist are untouched, and the cookie
  // (wishlistList) is left as it is, so anything already hearted stays.

  // ── BRANCH 2: Coming Soon — no cart: the release date and Notify Me ───────
  function addComingSoon(card, product, handle) {
    const media = card.querySelector(MEDIA_SELECTOR);
    if (media && !media.querySelector('.dcg-coming-soon-badge')) {
      const csBadge = document.createElement('span');
      csBadge.className = 'dcg-coming-soon-badge';
      csBadge.setAttribute(NODE_ATTR, '');
      csBadge.textContent = 'Coming Soon';
      media.appendChild(csBadge);
    }

    if (card.querySelector('.dcg-row3--coming-soon[' + NODE_ATTR + ']')) return;

    const row3 = document.createElement('div');
    row3.className = 'dcg-card-row3 dcg-row3--coming-soon';
    row3.setAttribute(NODE_ATTR, '');

    // row3: the release date, then Notify Me (V3.1.0, item 0: the heart that began the row is gone).
    const mapped = productsByHandle.get(handle);

    // Extract release date from title: the card's own title text first, as a
    // DCG card does; StorePass's display_name from the tag map if the card
    // has no title text.
    const titleEl = card.querySelector(TITLE_SELECTOR);
    const cardTitle = titleEl ? titleEl.textContent : '';
    const titleText = cardTitle.trim() ? cardTitle : ((mapped && mapped.title) || '');
    const releaseDate = extractReleaseDate(titleText);
    if (releaseDate) {
      const csLabel = document.createElement('span');
      csLabel.className = 'dcg-coming-soon-label';
      csLabel.textContent = 'Releasing ' + releaseDate;
      row3.appendChild(csLabel);
    }

    // Deep-links to the PDP's capture component (#dcg-notify).
    const csNotifyBtn = document.createElement('button');
    csNotifyBtn.className = 'dcg-notify-btn';
    csNotifyBtn.type = 'button';
    csNotifyBtn.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 2a6 6 0 0 1 6 6c0 3 1.5 4 1.5 5.5H2.5C2.5 12 4 11 4 8a6 6 0 0 1 6-6z" stroke="currentColor"/><path d="M8 15.5a2 2 0 0 0 4 0" stroke="currentColor"/></svg><span>Notify Me</span>';
    csNotifyBtn.addEventListener('click', () => {
      window.location.href = '/products/' + handle + '#dcg-notify';
    });
    row3.appendChild(csNotifyBtn);

    placeInCard(card, row3);
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §B2  CARD DRESS (DCG v2-6-2)
  // The DCG card (dcg-product-card.js buildCardUI) is the template. CSS in
  // dcg-storepass.css lays StorePass's own elements out as that card's rows;
  // this section adds the four things CSS cannot make from StorePass's markup,
  // and names StorePass's controls (5). Each is a node of ours (DRESS_ATTR),
  // an attribute on the card, or (5) an aria-label on a control. None of
  // StorePass's nodes is moved, replaced or rewritten, and StorePass's button
  // stays the element that is clicked. Every step writes only when something
  // differs, so a pass over a dressed card changes nothing.
  //
  //   1. Stock pip   .dcg-stock-pip, in the same row as the condition control
  //                  (dcg-product-card.js :343-350). Its text is StorePass's
  //                  own "N left" ("In stock" where StorePass gives no
  //                  count); none when the button is out of stock (V3.1.0,
  //                  the decisions round; "Out of stock" until then).
  //   2. Condition   .dcg-cond-label, laid over the closed <select>, reading
  //                  the condition only. StorePass's option text is
  //                  "Near Mint - $0.25" and belongs to React; the open list
  //                  still shows it.
  //   3. (Heart: .dcg-wishlist-wrap between quantity and Add to Cart, until
  //      V3.1.0; D-SP-41 amended: no card carries a heart.)
  //   4. Image stage data-dcg-media on the card: "single" (dark stage,
  //                  picture edge to edge) or "sealed" (white stage, 8px
  //                  inset), by the DCG card's own test (isSingleCard).
  //   5. Names       aria-label on StorePass's quantity buttons, quantity box
  //                  and condition select (v2-10-11); nothing seen changes.
  // ═════════════════════════════════════════════════════════════════════════

  // dcg-product-card.js :193-213, unchanged. Its second list, of product
  // types, is left out: isSingleCard reads the type from data-product-type,
  // and no DCG card carries that attribute (snippets/dcg-product-card.liquid,
  // dcg-advanced-search.js), so on a real DCG card that test never applies.
  // A card is a single if a variant is a condition, or a tag says so.
  const CONDITION_PATTERNS = [
    'near mint', 'lightly played', 'moderately played', 'heavily played',
    'damaged', 'nm', 'lp', 'mp', 'hp', 'dmg',
    'graded', 'psa', 'bgs', 'cgc',
    '1st edition', 'unlimited', 'limited edition',
    'foil', 'reverse foil', 'holo', 'non-holo',
    'first edition', 'shadowless'
  ];
  const SINGLES_TAG_PATTERNS = [
    'single', 'singles', 'tcg-single', 'tcg_single',
    'magic-single', 'mtg-single', 'pokemon-single',
    'yugioh-single', 'ygo-single', 'fab-single',
    'one-piece-single', 'flesh-and-blood-single', 'riftbound-single'
  ];

  // The variants a card's <select> offers. StorePass writes each variant as
  // JSON into its option's value.
  function optionVariants(select) {
    const out = [];
    if (!select) return out;
    for (let i = 0; i < select.options.length; i++) {
      try { const v = JSON.parse(select.options[i].value); if (v && typeof v === 'object') out.push(v); } catch (_) {}
    }
    return out;
  }
  function selectedVariant(select) {
    if (!select) return null;
    try { const v = JSON.parse(select.value); return (v && typeof v === 'object') ? v : null; } catch (_) { return null; }
  }
  // Nothing left to pick: every option reads as zero stock. An option that
  // cannot be read that way counts as in stock (the same test the sold-out
  // rules in dcg-storepass.css make on the option values).
  function nothingInStock(select) {
    const variants = optionVariants(select);
    return variants.length > 0 && select.options.length === variants.length &&
      variants.every(v => typeof v.inventory_quantity === 'number' && v.inventory_quantity <= 0);
  }
  function isOutOfStock(card) {
    const cta = card.querySelector(CTA_SELECTOR);
    return !!cta && cta.classList.contains(OOS_CLASS);
  }
  // The select area carries the pip and the label unless a rule state has
  // hidden it (retail, coming-soon).
  function usableSelectArea(card, state) {
    if (state && state !== 'price-pending') return null;
    const area = card.querySelector(SELECT_AREA_SELECTOR);
    return (area && area.querySelector('select')) ? area : null;
  }
  function removeNode(node) { if (node && node.parentNode) node.parentNode.removeChild(node); }

  // 4. Image stage — dcg-product-card.js isSingleCard (:215-239).
  function dressMedia(card, product) {
    const select = card.querySelector(SELECT_SELECTOR);
    let titles = optionVariants(select).map(v => v.title);
    if (!titles.length && product && product.variantTitles) titles = Array.from(product.variantTitles);
    let kind = '';
    if (titles.some(t => { const tl = String(t || '').toLowerCase(); return CONDITION_PATTERNS.some(p => tl.includes(p)); })) {
      kind = 'single';
    } else if (product) {
      const tags = product.tags || [];
      kind = tags.some(t => SINGLES_TAG_PATTERNS.some(p => String(t).toLowerCase().includes(p))) ? 'single' : 'sealed';
    }
    if ((card.getAttribute(MEDIA_ATTR) || '') === kind) return;
    if (kind) card.setAttribute(MEDIA_ATTR, kind); else card.removeAttribute(MEDIA_ATTR);
  }

  // 1. Stock pip — pipClass / pipLabel (:155-167): 1 to 4 left is "low".
  function dressStock(card, info, state) {
    let text = '', cls = '';
    // a coming-soon DCG card shows no pip; DCG v2-10-12 (item 4; D-SP-40, PROPOSED): nor does a retail card,
    // which is bought in store only, whatever its stock (its "In-store only" row and Retail Only badge say so).
    // V3.1.0, the decisions round (D-SP-32 LOCKED with one change; Cole, 17 OCT; REPORT-V3-1-0-final §7.3 (b)):
    // nor does a card whose button is out of stock. On a sold-out card its Sold Out picture and its button say it;
    // where an out-of-stock condition is picked on a card that has stock in another, its button says it. Until then
    // the pip read "Out of stock" (grey, "no"); a card with stock keeps its "N left" or "In stock" as before.
    if (state !== 'coming-soon' && state !== 'retail' && state !== 'retail-preorder' && !isOutOfStock(card)) {
      const sp  = card.querySelector(STOCK_SELECTOR);
      const raw = sp ? sp.textContent.replace(/\s+/g, ' ').trim() : '';
      const n   = parseInt(raw, 10);
      if (raw) { text = raw; cls = (n > 0 && n <= 4) ? 'low' : 'in'; }
      else if (card.querySelector(CTA_SELECTOR)) { text = 'In stock'; cls = 'in'; }
    }
    let pip = card.querySelector('.dcg-stock-pip[' + DRESS_ATTR + ']');
    let row = info.querySelector(':scope > .dcg-card-row1[' + DRESS_ATTR + ']');
    // DCG v2-10-4 (item 1): the row is on every card, with or without a badge.
    // A card with no badge (coming soon) and no condition control keeps an
    // empty row where the others have theirs, as the DCG card does (its row 1
    // is always there, dcg-product-card.js). A card that has the control has
    // its row already: StorePass's own select area.
    if (!text) {
      removeNode(pip);
      if (usableSelectArea(card, state)) removeNode(row);
      else if (!row) {
        row = document.createElement('div');
        row.className = 'dcg-card-row1';
        row.setAttribute(DRESS_ATTR, '');
        info.insertBefore(row, info.firstChild);
      }
      return;
    }

    // Beside the condition control when the card has one. Otherwise in a row
    // of its own, where the DCG card's row 1 is (its select is hidden then).
    let target = usableSelectArea(card, state);
    if (target) { if (row) { if (pip && pip.parentNode === row) removeNode(pip), pip = null; removeNode(row); } }
    else {
      if (!row) {
        row = document.createElement('div');
        row.className = 'dcg-card-row1';
        row.setAttribute(DRESS_ATTR, '');
        info.insertBefore(row, info.firstChild);
      }
      target = row;
    }
    if (!pip) {
      pip = document.createElement('span');
      pip.className = 'dcg-stock-pip';
      pip.setAttribute(DRESS_ATTR, '');
    }
    if (pip.parentNode !== target) target.appendChild(pip);
    // in | low | no: the DCG card's s-in / s-low / s-no, as an attribute
    if (pip.getAttribute('data-dcg-stock') !== cls) pip.setAttribute('data-dcg-stock', cls);
    if (pip.textContent !== text) pip.textContent = text;
  }

  // 2. Condition label over the closed <select>.
  function dressCondition(card, state) {
    const area   = usableSelectArea(card, state);
    const select = area ? area.querySelector('select') : null;
    let label = card.querySelector('.dcg-cond-label[' + DRESS_ATTR + ']');
    const variant = selectedVariant(select);
    if (!select || !variant || !variant.title) { removeNode(label); return; }

    // dcg-product-card.js :358-363: a sold-out card's select reads "Sold out".
    const text = (isOutOfStock(card) && nothingInStock(select)) ? 'Sold out' : String(variant.title);
    if (!label) {
      label = document.createElement('span');
      label.className = 'dcg-cond-label';
      label.setAttribute(DRESS_ATTR, '');
      label.setAttribute('aria-hidden', 'true');   // the <select> itself is what is announced
    }
    if (label.parentNode !== area) area.insertBefore(label, select.nextSibling);
    if (label.textContent !== text) label.textContent = text;
    // DCG v2-8-1: the label is in the row's flow and wraps (dcg-storepass.css),
    // so it no longer needs the pip's width; the property v2-6-2 set is taken off.
    if (label.style.getPropertyValue('--dcg-pip-w')) label.style.removeProperty('--dcg-pip-w');
  }

  // 5. Names (DCG v2-10-11 item 6). StorePass's quantity − and + are buttons
  // holding a picture only, and its quantity box and condition select have
  // no label (Cowork, 16 OCT: 62 buttons, 60 selects, 60 boxes on one page).
  // Each is given a name with the card's own: aria-label only, nothing seen
  // changes. Written only when it differs, on every pass, as React redraws.
  function nameNode(node, text) {
    if (node && node.getAttribute('aria-label') !== text) node.setAttribute('aria-label', text);
  }
  function dressNames(card) {
    const title = card.querySelector(TITLE_SELECTOR);
    const name = title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
    const of = name ? ' for ' + name : '';
    const qty = card.querySelector('.store-pass-product-quantity-section');
    if (qty) {
      const buttons = qty.querySelectorAll('button');
      if (buttons.length >= 2) { nameNode(buttons[0], 'Decrease quantity' + of); nameNode(buttons[buttons.length - 1], 'Increase quantity' + of); }
      nameNode(qty.querySelector('input'), 'Quantity' + of);
    }
    nameNode(card.querySelector(SELECT_SELECTOR), 'Condition' + of);
    // V3.1.0 (item 10): the picture link holds a picture drawn as a background, no words, so it had no name
    if (name) nameNode(card.querySelector('.store-pass-product-image-container a[href]'), name);
  }

  function dressCard(card, handle, product, state) {
    const info = card.querySelector(INFO_SELECTOR);
    if (!info) return;
    dressMedia(card, product);
    dressStock(card, info, state);
    dressCondition(card, state);
    dressNames(card);
  }

  function decorateCard(card) {
    const link    = card.querySelector(LINK_SELECTOR);
    const handle  = link ? handleFromUrl(link.getAttribute('href')) : null;
    const product = handle ? productForCard(handle) : null;
    try { openOnPrinting(card, handle); } catch (_) { /* the card stays on StorePass's own choice */ }
    const state   = decorateRuleState(card, handle, product);
    try { dressCard(card, handle, product, state); }
    catch (err) { console.warn('[DCG guard] card dress failed:', err); }
  }

  // Retail, coming-soon and price-pending (§B). Returns the state it left the card in.
  function decorateRuleState(card, handle, product) {
    let state     = (product && product.tags) ? ruleState(product.tags) : '';
    // Retail / coming-soon come first. Otherwise: is the selected variant $0.00?
    if (!state && product && product.tags && selectedVariantPricePending(card, product)) {
      state = 'price-pending';
    }

    const builtFor = card.getAttribute(HANDLE_ATTR) || '';
    if ((card.getAttribute(STATE_ATTR) || '') !== state || (state && builtFor !== handle)) {
      clearCard(card);
    }
    if (!state) return state;

    if (card.getAttribute(STATE_ATTR) !== state) card.setAttribute(STATE_ATTR, state);
    if (builtFor !== handle) card.setAttribute(HANDLE_ATTR, handle);

    // Re-checked on every pass: StorePass re-renders these on sort, filter,
    // paging and variant change.
    if (state === 'price-pending') {
      hideControls(card, PRICE_CONTROL_SELECTOR);
      addPriceNotice(card);
      return state;
    }
    hideControls(card, CONTROL_SELECTOR);
    if (state === 'coming-soon') {
      addComingSoon(card, product, handle);
    } else {
      addRetailBadge(card);
      addRetailNotice(card, state, product);
    }
    return state;
  }

  function decorateAll() {
    const listing = document.getElementById(LISTING_ID);
    if (!listing) return;
    listing.querySelectorAll(CARD_SELECTOR).forEach(card => {
      try { decorateCard(card); }
      catch (err) { console.warn('[DCG guard] card decoration failed:', err); }
    });
  }

  // Coalesce bursts (a StorePass render is hundreds of mutations) into one
  // pass per frame. Our own insertions re-trigger the observer once; that pass
  // finds every card already decorated and writes nothing, so it settles.
  // A hidden tab is given no animation frames, so there the pass runs on a
  // timer: decoration must not wait for the tab to be shown.
  let decorateQueued = false;
  function runDecorate() {
    if (!decorateQueued) return;   // this pass has already run
    decorateQueued = false;
    try { decorateAll(); }
    catch (err) { console.warn('[DCG guard] decoration failed:', err); }
  }
  function scheduleDecorate() {
    if (decorateQueued) return;
    decorateQueued = true;
    if (!document.hidden && typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(runDecorate);
    } else {
      setTimeout(runDecorate, 16);
    }
  }
  // A pass queued on a frame, and the tab is hidden before that frame comes:
  // run it on the timer instead. The frame, when it does come, finds nothing
  // queued.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && decorateQueued) setTimeout(runDecorate, 16);
  });

  // Scoped to the results container only (see the observer notes in
  // dcg-cart-enforcer.js: document-wide observers pin heavy collection pages).
  function watchListing() {
    const listing = document.getElementById(LISTING_ID);
    if (!listing || typeof MutationObserver === 'undefined') return;
    new MutationObserver(scheduleDecorate).observe(listing, { childList: true, subtree: true });
    // D-SP-14: a new condition can turn "Price pending" on or off. React may
    // answer a variant change by rewriting text only, which the observer above
    // doesn't see, so the select's own change event asks for a pass too.
    // v2-6-2: the condition label (§B2) follows the select at once, on the
    // same event, so it never reads the condition that was just left.
    const onPick = e => {
      if (!e.target || !e.target.matches || !e.target.matches(SELECT_SELECTOR)) return;
      const card = e.target.closest(CARD_SELECTOR);
      if (card) { try { dressCondition(card, card.getAttribute(STATE_ATTR) || ''); } catch (_) {} }
      scheduleDecorate();
    };
    listing.addEventListener('change', onPick);
    listing.addEventListener('input', onPick);
    scheduleDecorate();
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §C  CLICK BACKSTOP
  // Only StorePass posts FormData to /cart/add.js. Every DCG caller
  // (dcg-cart-bridge.js:41, top singles, events, decklist) sends a JSON string
  // and is passed straight through by the wrapper below.
  // ═════════════════════════════════════════════════════════════════════════

  // Shopify's own answer for a product, from /products/<handle>.js:
  // handle → Promise<{ handle, title, tags, variantIds, variantPrices } | null>.
  // variantPrices: Map<variantId, cents> (Shopify's .js gives cents).
  // Kept for the life of the page. A request that fails (network, non-200,
  // unusable body) resolves to null and is dropped, so the next click retries.
  const shopifyProducts = new Map();

  function fetchShopifyProduct(handle) {
    let pending = shopifyProducts.get(handle);
    if (pending) return pending;

    pending = upstreamFetch.call(window, '/products/' + encodeURIComponent(handle) + '.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(res => (res.ok ? res.json() : null)).then(data => {
      if (!data || !Array.isArray(data.tags) || !Array.isArray(data.variants)) return null;
      return {
        fromShopify: true,
        handle: handle,
        productId: data.id != null ? String(data.id) : '',
        title: String(data.title || ''),
        tags: normaliseTags(data.tags),
        variantIds: new Set(data.variants.filter(v => v && v.id != null).map(v => String(v.id))),
        variantPrices: new Map(data.variants
          .filter(v => v && v.id != null && v.price !== null && v.price !== undefined && v.price !== '' && Number.isFinite(Number(v.price)))
          .map(v => [String(v.id), Math.round(Number(v.price))]))
      };
    }).catch(() => null).then(product => {
      if (!product) shopifyProducts.delete(handle);
      return product;
    });

    shopifyProducts.set(handle, pending);
    return pending;
  }

  // Tags for the variant being added. Shopify is always asked first (the tag
  // map is StorePass's index and can lag or lack DCG's rule tags); the map is
  // used only when Shopify could not be asked. null = cannot be resolved.
  async function resolveProduct(variantId, sectionsUrl) {
    // Product URL StorePass put in the form, then the map's handle for this
    // variant if it names a different product.
    const mappedHandle = handleByVariantId.get(variantId);
    const handles = [handleFromUrl(sectionsUrl), mappedHandle]
      .filter((h, i, all) => h && all.indexOf(h) === i);

    let shopifyAnswered = false;
    for (const handle of handles) {
      const product = await fetchShopifyProduct(handle);
      if (!product) continue;
      shopifyAnswered = true;
      // The URL must really be this variant's product, or its tags prove nothing.
      if (product.variantIds.has(variantId)) return product;
    }

    // Every request failed: fall back to the tag map. If Shopify did answer
    // but the variant is in none of those products, stay unresolved.
    if (!shopifyAnswered) {
      const mapped = productsByHandle.get(mappedHandle);
      if (mapped && mapped.tags) return mapped;
    }
    return null;
  }

  // Shopify says retail / coming-soon and StorePass's index doesn't say the
  // same: put it on the override list so the card is redrawn with the notice
  // now and after every later re-render (§B reads clickOverrides first).
  function recordOverride(product, state) {
    if (!product.fromShopify) return;   // map fallback: the card already follows the map
    const mapped = productsByHandle.get(product.handle);
    const mapState = (mapped && mapped.tags) ? ruleState(mapped.tags) : '';
    if (mapState === state) return;
    clickOverrides.set(product.handle, product);
    scheduleDecorate();
  }

  // D-SP-14: Shopify prices the clicked variant at $0.00 and StorePass's index
  // doesn't (it lags, or has no price for it): same override list, so the card
  // is redrawn with "Price pending" now and after every later re-render.
  function recordPriceOverride(product, variantId) {
    if (!product.fromShopify) return;   // map fallback: the card already follows the map
    const mapped = productsByHandle.get(product.handle);
    if (mapped && mapped.variantPrices.get(variantId) === 0) return;
    clickOverrides.set(product.handle, product);
    scheduleDecorate();
  }

  // Same refresh dcg-cart-bridge.js does after its own add (:62-71). StorePass
  // looks for <cart-notification>/<cart-drawer>, which this theme doesn't have.
  function refreshCart() {
    try {
      if (typeof window.adjustCartDropDown === 'function') {
        window.adjustCartDropDown();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (err) {
      console.warn('[DCG guard] cart refresh failed:', err);
    }
    // Always dispatch cart:updated so dcg-cart-enforcer.js runs its drawer audit.
    try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); } catch (_) {}
  }

  async function guardedAdd(args, formData) {
    try {
      const variantId    = String(formData.get('id') || '').trim();
      const requestedQty = Number(formData.get('quantity')) || 1;
      const sectionsUrl  = formData.get('sections_url');
      let quantity = requestedQty;

      const product = await resolveProduct(variantId, sectionsUrl);

      // ── Tags unknown: never send blind. The product page applies the rules.
      if (!product) {
        const message = 'Please add this item from its product page.';
        const path = productPagePath(sectionsUrl);
        if (path) window.location.assign(path);
        else toast(message);
        return blockedResponse(422, message);
      }

      // ── Retail / coming-soon: cart disabled, same as the DCG card ─────────
      const state = ruleState(product.tags);
      if (state) {
        const message = blockMessage(state, product.title);
        toast(message);
        recordOverride(product, state);
        return blockedResponse(422, message);
      }

      // ── Price pending (D-SP-14): a $0.00 variant is never sent ────────────
      // Shopify's price when Shopify answered (it wins over StorePass's
      // index); the index's price only when Shopify could not be asked.
      const knownPrice = product.variantPrices ? product.variantPrices.get(variantId) : undefined;
      const cents = typeof knownPrice === 'number' ? knownPrice : null;
      if (pricePending(cents, product.tags)) {
        toast(PRICE_PENDING_MESSAGE);
        recordPriceOverride(product, variantId);
        return blockedResponse(422, PRICE_PENDING_MESSAGE);
      }

      // ── Pre-flight enforcement (as dcg-cart-bridge.js:13-34) ──────────────
      const enforcer = window.DCG.enforcer;
      if (enforcer && typeof enforcer === 'object') {
        let blockedMessage = null;
        try {
          // The enforcer's registry is filled from DCG cards and there are none
          // on a StorePass page, so hand it this variant's tags first — without
          // them preflight finds no limit:N and passes everything. The price
          // goes with them (D-SP-14), so preflight has no need to ask Shopify
          // for it again.
          if (typeof enforcer.registerVariant === 'function') {
            enforcer.registerVariant(variantId, product.tags, null, cents);
          }
          const check = await enforcer.preflight(variantId, quantity);
          if (check.blocked) {
            blockedMessage = check.message || 'Purchase limit reached.';
          } else {
            // Qty was reduced — show reason, but still proceed with the add
            if (check.message) toast(check.message);
            quantity = Number(check.qty) || quantity;
          }
        } catch (enforceErr) {
          // Failure inside preflight: log and allow the add (bridge behaviour)
          console.warn('[DCG] enforcer preflight error — allowing add:', enforceErr);
        }
        if (blockedMessage) {
          toast(blockedMessage);
          return blockedResponse(422, blockedMessage);
        }
      }

      // ── Send. StorePass's own request goes out untouched unless preflight
      //    reduced the quantity, in which case a copy of its form is sent.
      let sendArgs = args;
      if (quantity !== requestedQty) {
        const adjusted = new FormData();
        formData.forEach((value, key) => {
          adjusted.append(key, key === 'quantity' ? String(quantity) : value);
        });
        sendArgs = [args[0], Object.assign({}, args[1], { body: adjusted })];
      }

      let res;
      try {
        res = await upstreamFetch.apply(window, sendArgs);
      } catch (networkErr) {
        console.warn('[DCG guard] /cart/add.js request failed:', networkErr);
        return blockedResponse(503, 'Add to cart failed. Please try again.');
      }

      if (res.ok) refreshCart();
      return res;

    } catch (err) {
      // Unexpected failure in the guard itself: fail closed, never throw.
      console.warn('[DCG guard] add stopped after a guard error:', err);
      const message = 'Please add this item from its product page.';
      toast(message);
      return blockedResponse(422, message);
    }
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §D  CARD-STYLE TRIPWIRE
  // Everything above is built for StorePass's "modern-simple" card. The card
  // is picked by one dashboard setting (product_item_style), outside the
  // theme. Other values bring in cards that don't use Shopify's cart: the
  // bundle's default links to cardhaus.com/cart.php, and its fallback card
  // POSTs to /cart.php (BigCommerce). dcg-storepass.css hides those links;
  // here the /cart.php request is stopped and the setting is reported once.
  // ═════════════════════════════════════════════════════════════════════════

  const EXPECTED_CARD_STYLE = 'modern-simple';
  let cardStyleChecked = false;

  // `store` is the settings object the bundle is about to use.
  function checkCardStyle(store) {
    if (cardStyleChecked || !store || typeof store !== 'object') return;
    cardStyleChecked = true;
    const style = store.search_settings ? store.search_settings.product_item_style : undefined;
    if (style === EXPECTED_CARD_STYLE) return;
    console.warn('[DCG guard] StorePass product_item_style is ' +
      (style == null || style === '' ? '(unset)' : JSON.stringify(style)) +
      ', expected "' + EXPECTED_CARD_STYLE + '". Result cards may not use the Shopify cart. ' +
      'Check the card style in the StorePass dashboard.');
  }

  // The bundle takes its settings from one of three places: a local settings
  // file (#storepass-search-settings-json, none in this theme), the
  // storepass_store cookie it caches them in for 5 minutes, or a request to
  // /saas/store/settings. The two requests are seen by the fetch wrapper; the
  // cookie makes no request, so it is read here, the same way the bundle does.
  function localSettingsUrl() {
    const el = document.getElementById('storepass-search-settings-json');
    const url = el && el.getAttribute('data-url');
    try { return url ? new URL(url, window.location.href).href : null; }
    catch (_) { return null; }
  }

  function checkCardStyleFromCookie() {
    if (localSettingsUrl()) return;
    try {
      const raw = document.cookie.split(';').find(c => c.trim().startsWith('storepass_store='));
      if (raw) checkCardStyle(JSON.parse(decodeURIComponent(raw.split('=')[1])));
    } catch (_) { /* unreadable cookie: the bundle will request the settings instead */ }
  }

  // `res` is a clone; the bundle keeps the original.
  function checkCardStyleFromResponse(res) {
    res.json().then(data => { checkCardStyle(data && data.store); recordKeptParameters(data && data.store); }).catch(() => {});
  }

  // DCG v2-8 (D-SP-23): which address parameters StorePass has been told to
  // keep, read from the settings it actually loaded: the local settings file,
  // or its own answer when that file could not be fetched. The filter panel
  // offers a group on one of these keys only when the key is in the list, so
  // when the page falls back to StorePass's own settings no group appears
  // that would do nothing. null until a settings answer has been read.
  let keptParameters = null;
  function recordKeptParameters(store) {
    try {
      const list = store && store.search_settings && store.search_settings.custom_data_filters;
      keptParameters = Array.isArray(list) ? list.map(x => (x && x.parameter) ? String(x.parameter) : '').filter(Boolean) : [];
      document.dispatchEvent(new CustomEvent('dcg:storepass-settings', { detail: { parameters: keptParameters.slice() } }));
    } catch (_) { /* never into StorePass */ }
  }

  // /cart.php is not a Shopify endpoint. The request is never sent. If it
  // names a product this page knows (product_id in the query or the body),
  // the customer goes to that product's page; otherwise nothing more happens.
  function blockedCartPhp(url, init) {
    try {
      let productId = url.searchParams.get('product_id');
      const body = init && init.body;
      if (!productId && body) {
        if (typeof body === 'string') productId = new URLSearchParams(body).get('product_id');
        else if (typeof body.get === 'function') productId = body.get('product_id');   // URLSearchParams, FormData
      }
      const handle = productId ? handleByProductId.get(String(productId)) : null;
      if (handle) window.location.assign('/products/' + encodeURIComponent(handle));
    } catch (err) {
      console.warn('[DCG guard] /cart.php request stopped; product not resolved:', err);
    }
    return Promise.resolve(blockedResponse(404, 'This store has no /cart.php. Please use the product page.'));
  }

  // ── fetch wrapper ─────────────────────────────────────────────────────────

  function requestUrl(input) {
    const raw = typeof input === 'string' ? input : ((input && input.url) || String(input));
    return new URL(raw, window.location.href);
  }

  function classify(input, init) {
    const url = requestUrl(input);
    const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();

    if (/\/cart\.php$/i.test(url.pathname)) return 'cartphp';

    // StorePass's API host is a remote setting (api_base_url), so match the path.
    if (method === 'GET' && /\/saas\/search\/?$/.test(url.pathname)) return 'search';
    if (method === 'GET' &&
        (/\/saas\/store\/settings\/?$/.test(url.pathname) || url.href === localSettingsUrl())) {
      return 'settings';
    }

    if (method === 'POST' &&
        url.origin === window.location.origin &&
        /\/cart\/add\.js$/.test(url.pathname) &&
        typeof FormData !== 'undefined' &&
        init && init.body instanceof FormData) {
      return 'add';
    }
    return null;
  }

  // ═════════════════════════════════════════════════════════════════════════
  // BRIDGE  Printing by bare tag (D-SP-20, D-SP-22, DCG v2-8)
  // The filter panel keeps the customer's printing in the address as
  // `printing=<tag>`; StorePass sends that key with its search and its search
  // ignores it. Here the bare BinderPOS tag is added to the request, so the
  // tag never enters StorePass's own state (its Sort throws on a tag read
  // from the address). dcg-storepass-filters.js decides whether a tag is
  // wanted (its games table; a bridge switched off there gives none).
  // Returns the address to request in place of StorePass's, or null.
  // ═════════════════════════════════════════════════════════════════════════
  function bridgedSearchUrl(input) {
    const filters = window.DCG && window.DCG.storepassFilters;
    if (!filters || typeof filters.tagsFor !== 'function') return null;
    if (typeof input !== 'string' && !(typeof URL !== 'undefined' && input instanceof URL)) return null;   // a Request object is left alone
    const url = new URL(String(input), window.location.href);
    const tag = filters.tagsFor(url.searchParams);
    if (!tag) return null;
    const have = String(url.searchParams.get('tags') || '').split(',').map(t => t.trim()).filter(Boolean);
    if (have.indexOf(tag) !== -1) return null;
    have.push(tag);
    url.searchParams.set('tags', have.join(','));
    return url.toString();
  }

  // ═════════════════════════════════════════════════════════════════════════
  // SET KEPT  (D-SP-39, PROPOSED; DCG v2-10-11 item 1a)
  // storepass.js's own Sort, In Stock Only and price search rebuild the
  // request from its own state (handleFilterSubmit), which holds no set when
  // the set came from the address, the filter panel's way in: the request
  // says set_name= (empty), and the search for the whole collection went
  // (by a real click, 16 OCT: One Piece "Adventure on Kami's Island" 111 ->
  // 1,935; Riftbound "Riftbound Promotional Cards" 29 -> 2,011;
  // docs/REPORT-v2-10-11.md §1). The set the customer chose is put back into
  // that request on the way out, as the Printing tag is above: the filter
  // panel's (dcg-storepass-filters.js wantedSet()), or, without the panel,
  // the set of storepass.js's last listing search that held one (read from
  // the address on the way in). Only a listing search (it names a product
  // line) that carries set_name empty is touched. One with no set_name at
  // all (the set taken off by its pill, Clear, Back to an address with
  // none) goes as it is. The address and StorePass's own pill come back by
  // the panel's set repair (§F there), which stays as the net.
  // ═════════════════════════════════════════════════════════════════════════
  let lastSet = null;
  function chosenSet() {
    const filters = window.DCG && window.DCG.storepassFilters;
    if (filters && typeof filters.wantedSet === 'function') return filters.wantedSet() || null;
    return lastSet;
  }
  function settedSearchUrl(input) {
    if (typeof input !== 'string' && !(typeof URL !== 'undefined' && input instanceof URL)) return null;   // a Request object is left alone
    const url = new URL(String(input), window.location.href);
    const p = url.searchParams;
    if (p.get('return_type') || !p.get('product_line')) return null;
    if (!p.has('set_name')) { lastSet = null; return null; }
    if (p.get('set_name')) { lastSet = p.get('set_name'); return null; }
    const set = chosenSet();
    if (!set) return null;
    p.set('set_name', set);
    return url.toString();
  }

  // The card opens on the printing that was asked for (Cole, D-SP-22): a
  // tagged product HOLDS the printing, in stock or not. Its condition select
  // is put on a variant of that printing, one in stock if there is one, else
  // the first; StorePass then shows that variant, sold out when it is. Done
  // once for a card and a choice, so the customer's own pick afterwards
  // stands. No card is hidden and the result count is left alone.
  const PRINTING_ATTR = 'data-dcg-printing';
  const CONDITION_PREFIX = /^(Near Mint|Lightly Played|Moderately Played|Heavily Played|Damaged)\s*/i;
  const printingOfTitle = title => String(title || '').replace(CONDITION_PREFIX, '').trim() || 'Normal';
  function openOnPrinting(card, handle) {
    const filters = window.DCG && window.DCG.storepassFilters;
    const tag = (filters && typeof filters.chosenTag === 'function') ? filters.chosenTag() : null;
    if (!tag || !handle) { if (card.hasAttribute(PRINTING_ATTR)) card.removeAttribute(PRINTING_ATTR); return; }
    const key = handle + '|' + tag;
    if (card.getAttribute(PRINTING_ATTR) === key) return;
    const select = card.querySelector(SELECT_SELECTOR);
    if (!select) return;                                   // one variant: nothing to open
    let first = -1, stocked = -1;
    for (let i = 0; i < select.options.length; i++) {
      let v = null;
      try { v = JSON.parse(select.options[i].value); } catch (_) { v = null; }
      if (!v || typeof v !== 'object' || printingOfTitle(v.title) !== tag) continue;
      if (first === -1) first = i;
      if (stocked === -1 && typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0) stocked = i;
    }
    card.setAttribute(PRINTING_ATTR, key);
    const want = stocked !== -1 ? stocked : first;
    if (want === -1 || select.selectedIndex === want) return;
    select.selectedIndex = want;
    select.dispatchEvent(new Event('change', { bubbles: true }));   // StorePass's own handler redraws the card
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §J  ONE SEARCH PER CHANGE (DCG V3.1.2, item 6; Cole, 20 OCT;
  //     docs/PROMPT-V3-1-2-adjustments.md)
  // Measured on the draft as first pushed (tests/skin/filter-requests-probe.js,
  // docs/img/v3-1-2/before/): each filter change on a singles collection sent
  // three requests of storepass.js's own that differ in two or three keys and
  // look the same in a browser's list (its page of cards; the same with
  // with_count=true, its count; return_type=custom_filter, the values of its
  // Product Type group, which has one value on a singles collection); after a
  // set was chosen in the panel, a Sort or In Stock Only sent all three twice
  // (the set repair re-reads the address: the same search with its empty keys
  // left out); a choice made again (In Stock Only pressed twice) asked again.
  // Here, for every StorePass search that goes through this file:
  //   - a search asked for again, the same in every key that holds a value
  //     (empty keys, the order of keys and the way a value is written aside;
  //     a count and a value list whatever the sort; a value list whatever the
  //     page size or page), while its answer is on its way or within a short
  //     time after (2 minutes for a page of cards, 5 for a count or a list), is
  //     given that answer: no request leaves; the page's own handlers see it
  //     answered as any search is;
  //   - the values of a group that has one value on a listing (its answer had
  //     one, the search narrowed by nothing but In Stock Only) are given that
  //     one value for every narrower search of the same listing (in stock: the
  //     same listing's in stock, or the whole listing's, as In Stock Only can
  //     only take values away); the panel hides such a group
  //     (dcg-storepass-filters.js). storepass.js asks for the Product Type
  //     group's values only from the first change on a page (not at its load:
  //     measured 20 OCT 23:30), so that first change sends its value list;
  //     the changes after it on the same page do not;
  //   - a search of the listing still on its way when the next change's search
  //     of the same kind leaves is overtaken: its request is cancelled and its
  //     caller is given the newer answer, so no older answer can be drawn over
  //     a newer one; nothing is said for it (watchSearch's quiet()).
  // A page of cards for a new combination of filters still needs its count:
  // StorePass's page answer counts only itself and its count answer holds no
  // products (since its 14 OCT release; measured 20 OCT), so a new filter is
  // two requests, a sort one (its count and its values are those of the same
  // filters), a choice made before none.
  // ═════════════════════════════════════════════════════════════════════════
  const SEARCH_TTL = { page: 120000, count: 300000, list: 300000 };
  const SEARCH_KEEP = 24;
  const searches = new Map();            // key -> entry { key, kind, slot, at, raw, res, ctl, done, overtakenBy }
  const inFlight = new Map();            // slot -> the listing's newest entry of that kind still on its way
  const singleValues = new Map();        // listing|key|stock -> the one-value answer of that group, as JSON
  const searchKind = url => (url.searchParams.get('return_type') ? 'list' : url.searchParams.get('with_count') === 'true' ? 'count' : 'page');
  // the keys that narrow a search (everything but where, how many, in what order and the passive keys)
  const BROAD_KEYS = ['store_id', 'mongo', 'override_buylist_gt_price', 'product_line', 'sort', 'limit', 'fields', 'convert_to_currency', 'round_price', 'shopify_collection_id', 'page', 'skip', 'with_count', 'no_track', 'shopify_page_parameters', 'return_type', 'custom_filter_key', 'unique_q', 'in_stock', 'name', 'big_commerce_category_ids', 'brand_name'];
  function oneSearchKey(url) {
    const kind = searchKind(url), parts = [];
    url.searchParams.forEach((v, k) => {
      if (v === '' || k === 'no_track') return;
      if (kind !== 'page' && k === 'sort') return;                       // a count, a value list: whatever the sort
      if (kind === 'list' && (k === 'limit' || k === 'page' || k === 'skip')) return;
      parts.push(k + '=' + v);
    });
    return kind + '|' + url.origin + url.pathname + '?' + parts.sort().join('&');
  }
  // the listing a search is of, and the kind of answer: only a search of the listing itself is overtaken
  function oneSearchSlot(url) {
    try {
      if (!document.getElementById('product-listing-container')) return null;
      const p = url.searchParams, kind = searchKind(url);
      if (!p.get('product_line')) return null;
      const size = listingSize();
      if (kind !== 'list' && !(size !== null && parseInt(p.get('limit'), 10) === size)) return null;
      return [kind, kind === 'list' ? (p.get('return_type') + ':' + (p.get('custom_filter_key') || '')) : '', p.get('shopify_collection_id') || '', p.get('product_line') || ''].join('|');
    } catch (_) { return null; }
  }
  function narrowed(url) {
    let n = false;
    url.searchParams.forEach((v, k) => { if (v !== '' && BROAD_KEYS.indexOf(k) === -1) n = true; });
    return n;
  }
  function singleSlot(url, stock) {
    const p = url.searchParams;
    if (p.get('return_type') !== 'custom_filter' || !p.get('custom_filter_key')) return null;
    return [p.get('custom_filter_key'), p.get('shopify_collection_id') || '', p.get('product_line') || '', p.get('name') || '', p.get('q') || '', stock || (p.get('in_stock') ? 'in stock' : 'all')].join('|');
  }
  // a group's one value for this search: the listing's in the same stock, or (a search in stock) the whole listing's:
  // In Stock Only can only take values away
  function singleFor(url) {
    const same = singleValues.get(singleSlot(url));
    if (same) return same;
    return url.searchParams.get('in_stock') ? singleValues.get(singleSlot(url, 'all')) || null : null;
  }
  function forgetSearch(entry) { if (searches.get(entry.key) === entry) searches.delete(entry.key); }
  function keepSearch(entry) {
    searches.set(entry.key, entry);
    while (searches.size > SEARCH_KEEP) searches.delete(searches.keys().next().value);
  }
  // a caller's own copy of an entry's answer; one an overtaken entry's caller follows to the newer answer
  function deliver(entry) {
    let followed = false;
    const promise = new Promise((resolve, reject) => {
      const follow = e => e.res.then(r => resolve(r.clone()), err => {
        if (e.overtakenBy) { followed = true; follow(e.overtakenBy); } else reject(err);
      });
      follow(entry);
    });
    return { promise, followed: () => followed };
  }
  function announceFacet(url, data) {
    try {
      const p = url.searchParams;
      if (p.get('return_type') !== 'custom_filter' || !data || !Array.isArray(data.products)) return;
      if (tagValueList(url)) return;     // (the end gates) the Tag group's count is said by §L, after the whitelist
      document.dispatchEvent(new CustomEvent('dcg:storepass-facet', { detail: { key: p.get('custom_filter_key') || '', values: data.products.length, narrowed: narrowed(url), collection: p.get('shopify_collection_id') || '' } }));
    } catch (_) {}
  }
  // Returns { promise, served, followed } for StorePass's search, or null: then it goes as it came (anything unexpected)
  function oneSearch(args, url) {
    if (typeof args[0] !== 'string' && !(typeof URL !== 'undefined' && args[0] instanceof URL)) return null;   // a Request object: as it came
    const init = args[1];
    if (init && (init.signal || (init.method && String(init.method).toUpperCase() !== 'GET'))) return null;
    const kind = searchKind(url), key = oneSearchKey(url), now = Date.now();
    // a group's one value, for a narrower search of the same listing
    const single = kind === 'list' ? singleFor(url) : null;
    if (single) return { promise: Promise.resolve(new Response(single, { status: 200, headers: { 'Content-Type': 'application/json; charset=utf-8' } })), served: 'one value', followed: () => false };
    const slot = oneSearchSlot(url);
    // the listing's older search of the same kind, still on its way when this change's search leaves (or is answered
    // at once): overtaken. Its request is cancelled and its caller follows this one, so its answer cannot be drawn
    // over this one's when it comes late.
    const overtake = by => {
      const older = slot ? inFlight.get(slot) : null;
      if (!older || older.done || older.key === by.key || older === by) return;
      older.overtakenBy = by;
      forgetSearch(older);
      try { if (older.ctl) older.ctl.abort(); } catch (_) {}
    };
    const had = searches.get(key);
    if (had && (!had.done || now - had.at <= SEARCH_TTL[kind])) {
      overtake(had);
      if (slot && !had.done) inFlight.set(slot, had);
      const d = deliver(had);
      return { promise: d.promise, served: had.done ? 'answered' : 'on its way', followed: d.followed };
    }
    const ctl = typeof AbortController === 'function' ? new AbortController() : null;
    const entry = { key, kind, slot, at: now, ctl, done: false, overtakenBy: null };
    overtake(entry);
    const opts = Object.assign({}, init || {});
    if (ctl) opts.signal = ctl.signal;
    let raw;
    try {
      // §K (the addendum): a page of the listing with In Stock Only off is answered in-stock first
      raw = kind === 'page' && stitchable(url) ? stitched(args, url, ctl ? ctl.signal : null) : upstreamFetch.call(window, args[0], opts);
    } catch (e) { raw = Promise.reject(e); }
    entry.res = raw.then(r => {
      entry.done = true; entry.at = Date.now();
      if (!r || !r.ok) forgetSearch(entry);
      else if (kind === 'list') {
        // the values of a group: kept as its one value when the listing's whole search has one
        r.clone().json().then(data => {
          announceFacet(url, data);
          if (data && Array.isArray(data.products) && data.products.length === 1 && !narrowed(url)) singleValues.set(singleSlot(url), JSON.stringify(data));
        }).catch(() => {});
      }
      return r;
    }, err => { entry.done = true; forgetSearch(entry); throw err; });
    entry.res.catch(() => {});
    keepSearch(entry);
    if (slot) inFlight.set(slot, entry);
    const d = deliver(entry);
    return { promise: d.promise, served: false, followed: d.followed };
  }

  window.fetch = function dcgStorePassGuardFetch(input, init) {
    let kind = null;
    try { kind = classify(input, init); } catch (_) { kind = null; }

    if (kind === 'search') {
      // BRIDGE (D-SP-22): a search that carries `printing=Foil` leaves with
      // `tags=Foil` as well. Anything unexpected: the request goes as it came.
      let args = arguments;
      try { const bridged = bridgedSearchUrl(input); if (bridged) args = [bridged, init]; } catch (_) { args = arguments; }
      // v2-10-11 (item 1a; D-SP-39): the chosen set, when storepass.js's own rebuild left it out
      try { const withSet = settedSearchUrl(args[0]); if (withSet) args = [withSet, init]; } catch (_) {}
      // v2-10-10 (item 1a): a short sort name leaves as its label; v2-10-11 (item 3): in_stock=undefined as true
      try { const labelled = labelledSearchUrl(args[0]); if (labelled) args = [labelled, init]; } catch (_) {}
      let asked = null;
      try { asked = requestUrl(args[0]); } catch (_) { asked = null; }
      // V3.1.2 (item 6, §J): one request for a search asked for again, a group's one value, an overtaken search
      // following the newer; anything unexpected, the request as it came (StorePass then gets that very promise)
      // the addendum (§L, D-SP-49): the Tag group's values, the groups the settings file names; an empty list asks nothing
      try {
        const named = asked && tagValueList(asked) ? tagGroups() : null;
        if (named && !named.length) { announceTags(asked, 0); return Promise.resolve(new Response(JSON.stringify({ count: 0, pages: 1, current_page: 1, products: [] }), { status: 200, headers: { 'Content-Type': 'application/json; charset=utf-8' } })); }
      } catch (_) {}
      let one = null;
      try { one = asked ? oneSearch(args, asked) : null; } catch (_) { one = null; }
      let pending = one ? one.promise : upstreamFetch.apply(window, args);
      try { if (asked && tagValueList(asked)) pending = pending.then(r => shownTags(r, asked)); } catch (_) {}
      // Our handler is attached first, so the clone is taken before StorePass starts reading the body.
      // v2-10-10 (item 1b): storepass.js's own count request, seen as it leaves (before its page's answer comes)
      try { if (asked && asked.searchParams.get('with_count') === 'true' && !asked.searchParams.get('return_type')) countsAsked.add(keep(countsAsked, pageKey(asked))); } catch (_) {}
      inStockFirstFor(asked);           // v2-10-8 (item 2): before StorePass reads its answer
      try { noteStock(asked); } catch (_) {}   // V3.1.2 (item 1): the visitor's In Stock Only, kept for the visit
      // V3.1.2, the addendum (§K): a page answered in-stock first is two or more searches; one answered by price (the two
      // price sorts on a singles listing) still has its in-stock count said for the count line
      let stitching = false;
      try { stitching = !!(asked && searchKind(asked) === 'page' && stitchable(asked)); if (asked && !stitching) noteInStock(asked); } catch (_) { stitching = false; }
      // v2-10-4 (D-SP-37): the search is announced as started, and as failed if
      // it is refused, is not a 200, or has no answer after 8 seconds (§K: 16 for
      // a page answered in-stock first, which reads more than one of StorePass's
      // pages at a seam)
      let watch = null;
      try { watch = watchSearch(asked, stitching ? SEARCH_PATIENCE * 2 : SEARCH_PATIENCE); } catch (_) { watch = null; }
      pending.then(res => {
        // §J: overtaken by the next change: its caller has the newer answer, which that search reports itself
        if (one && one.followed()) { try { if (watch) watch.quiet(); } catch (_) {} return; }
        try { if (watch) watch.answered(res); } catch (_) {}
        try { recordSearchResponse(res.clone(), asked); } catch (_) {}
      }, () => { try { if (watch) watch.failed(); } catch (_) {} });
      return pending;
    }

    if (kind === 'settings') {
      const pending = upstreamFetch.apply(window, arguments);
      pending.then(res => {
        try { checkCardStyleFromResponse(res.clone()); } catch (_) {}
        keepSettings(res);              // v2-10-8 (item 2): this runs before storepass.js's own handler reads it
      }, () => {});
      return pending;
    }

    if (kind === 'add') return guardedAdd(arguments, init.body);

    if (kind === 'cartphp') return blockedCartPhp(requestUrl(input), init);

    return upstreamFetch.apply(window, arguments);
  };

  // v2-10-8 (item 2): no in-stock-first reorder under the two price sorts.
  // StorePass's setting in_stock_first_per_page (true in the local settings
  // file) makes storepass.js put the in-stock cards of each collection page
  // first, whatever the sort; under "Price: Low-High" a row read $1.00,
  // $0.35, $0.35, $0.30, $1.05, $0.40, $166.65 (Cowork, 15 OCT). The setting
  // is one for every sort, and storepass.js is not edited (D-SP-02). It reads
  // the setting from the object the settings file was parsed into, when each
  // answer comes. That object is kept here as it is parsed, and the setting
  // is set when each search leaves: off under a price sort, the file's own
  // value under every other. Nothing else in it is touched.
  const PRICE_SORT = /^Price:/i;
  let spSearchSettings = null;           // the search_settings object storepass.js holds
  let inStockFirst = null;               // its in_stock_first_per_page as the file has it
  function keepSettings(res) {
    try {
      const own = res.json;
      res.json = function () {
        return own.apply(res, arguments).then(obj => {
          try {
            const ss = obj && obj.store && obj.store.search_settings;
            if (ss && typeof ss === 'object' && spSearchSettings === null) {
              dcgFile = obj.dcg && typeof obj.dcg === 'object' ? obj.dcg : null;   // the addendum: the theme's own block of the file
              try { ownSettings(obj, ss); } catch (_) {}   // (round 3, §M) the theme's parameters, before anything reads them
              spSearchSettings = ss; inStockFirst = ss.in_stock_first_per_page;
              liveStockDefault(ss);                        // V3.1.2 (item 1): the default in force, at every read
            }
          } catch (_) {}
          return obj;
        });
      };
    } catch (_) {}
  }
  // (Seen on the draft, 15 OCT 02:12: after a price-sorted page, storepass.js asks for its filter options three times
  // with return_type=custom_filter and no sort. Those draw no cards and leave the setting as it is.)
  function inStockFirstFor(url) {
    try {
      if (!spSearchSettings || inStockFirst !== true || !url || url.searchParams.has('return_type')) return;
      spSearchSettings.in_stock_first_per_page = PRICE_SORT.test(url.searchParams.get('sort') || '') ? false : inStockFirst;
    } catch (_) {}
  }

  // For checking on the draft theme: DCG.storepassGuard._getProducts()
  // (StorePass's index) and ._getOverrides() (click-time Shopify answers).
  // v2-10-8 (item 3a): one search made by the theme itself (the safety net's check of page 2), through the
  // fetch StorePass's own searches go through, but not announced: neither the net nor the pager takes it for
  // the listing's own search. Read only; the answer is { ok, products: [keys], cursor } or null when it failed.
  function quietSearch(href, patience) {
    return new Promise(resolve => {
      let done = false;
      const end = v => { if (!done) { done = true; resolve(v); } };
      setTimeout(() => end(null), patience || SEARCH_PATIENCE);
      let pending;
      try { pending = upstreamFetch.call(window, href, { credentials: 'omit' }); } catch (_) { end(null); return; }
      pending.then(res => (res && res.ok ? res.json() : null)).then(data => {
        if (!data || typeof data !== 'object' || !Array.isArray(data.products)) { end(null); return; }
        end({ ok: true, products: data.products.map(productKey), cursor: !!(data.nextPageParameters && data.nextPageParameters.page_info) });
      }, () => end(null));
    });
  }

  window.DCG.storepassGuard = {
    quietSearch:   quietSearch,
    pageSize:      listingSize,           // v2-10-11 (item 2): the listing's page size, for assets/dcg-storepass-paging.js
    inStockFirst:  () => (spSearchSettings ? { file: inStockFirst, now: spSearchSettings.in_stock_first_per_page } : null),
    // V3.1.2 (item 1): In Stock Only by default. stockDefaultOn: the default in force on this page is on (the file's,
    // the visit's choice not off, the page not holding it off); rememberStock(on): a choice made outside StorePass's
    // own controls (the safety net's switch); stockForPage(on | null): a page's own hold, not remembered (All Singles)
    // (21 OCT, the end gates: an address's in_stock wins for its page on the safety net too, as storepass.js reads it
    // for StorePass's own listing; the net read the default alone and listed Shopify's in-stock products under
    // ?in_stock=)
    // (only where the file has the default on: with it off, an address's in_stock=true is the visitor's own filter)
    // (the addendum: the file's default off, the visit's choice "on" is the default in force too; an address's in_stock is
    // the default's only where the file has it on, else the visitor's own filter, as before)
    stockDefaultOn: () => { const a = addressStock(); if (a !== null) return fileStockDefault === true ? a : false; return stockDefaultNow() === true; },
    // the addendum (D-SP-50, decided by Cole): In Stock Only is on by the visitor's choice (the address's, or the visit's
    // kept "on"), not by the file's default: a chip shows only then
    stockChosen:    () => addressStock() === true || (sessionStock() === 'on' && pageStock === null),
    rememberStock:  rememberStock,
    // (round 3, §M) where the settings storepass.js parsed came from, and what this file set to the theme's there
    themeParams:    () => ({ from: settingsFrom, overrode: themeOverrode.slice() }),
    forgetStock:    forgetStock,           // (the addendum's gate) "Clear all": the visit's In Stock Only choice forgotten
    stockForPage:   stockForPage,
    stockState:     () => ({ file: fileStockDefault, now: spSearchSettings ? spSearchSettings.in_stock_default : null, session: sessionStock() || 'none', page: pageStock, last: lastStock }),
    // the addendum (§K): in stock first across the whole listing; for checking
    inStockFirstWhole: () => ({ on: stitchOn(), fault: lastStitchFault, counts: Array.from(inStockCounts.entries()).map(([k, c]) => ({ key: k, count: c.count, exact: c.exact, fromPage: !!c.fromPage })), streams: Array.from(streams.entries()).map(([k, s]) => ({ key: k, out: s.items.length, read: s.read, done: s.done, none: s.none })) }),
    singlesListing: singlesListing,
    // the addendum (§L, D-SP-49): the tag groups the settings file names (null: no list in hand), whether a tag is shown,
    // and, for checking, what the Tag group's lists held back
    tagGroups:      tagGroups,
    tagShown:       tagShown,
    tagsHeld:       () => JSON.parse(JSON.stringify(tagsHeld)),
    decorate:      scheduleDecorate,
    lastResults:   () => ({ productTypes: lastResults.productTypes.slice(), products: lastResults.products }),
    keptParameters: () => (keptParameters === null ? null : keptParameters.slice()),
    _getProducts:  () => new Map(productsByHandle),
    _getOverrides: () => new Map(clickOverrides),
    // V3.1.2 (item 6, §J): for checking: the searches kept, and a way to forget them (a test's StorePass that answers the
    // same search differently from one load to the next, as time passing would)
    _getSearches:    () => Array.from(searches.values()).map(e => ({ key: e.key, kind: e.kind, done: e.done, at: e.at })),
    _forgetSearches: () => { searches.clear(); inFlight.clear(); singleValues.clear(); stitchSubs.clear(); inStockCounts.clear(); inStockAsks.clear(); streams.clear(); }
  };

  checkCardStyleFromCookie();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchListing);
  } else {
    watchListing();
  }
})();
